var items = {
  "block.minecraft.acacia_button": "相思木按鈕",
  "block.minecraft.acacia_door": "相思木門",
  "block.minecraft.acacia_fence": "相思木欄杆",
  "block.minecraft.acacia_fence_gate": "相思木閘門",
  "block.minecraft.acacia_hanging_sign": "相思木吊牌",
  "block.minecraft.acacia_leaves": "相思木樹葉",
  "block.minecraft.acacia_log": "相思木原木",
  "block.minecraft.acacia_planks": "相思木板",
  "block.minecraft.acacia_pressure_plate": "相思木壓力板",
  "block.minecraft.acacia_sapling": "相思木樹苗",
  "block.minecraft.acacia_shelf": "相思木置物架",
  "block.minecraft.acacia_sign": "相思木指示牌",
  "block.minecraft.acacia_slab": "相思木半磚",
  "block.minecraft.acacia_stairs": "相思木樓梯",
  "block.minecraft.acacia_trapdoor": "相思木地板門",
  "block.minecraft.acacia_wall_hanging_sign": "牆上的相思木吊牌",
  "block.minecraft.acacia_wall_sign": "牆上的相思木指示牌",
  "block.minecraft.acacia_wood": "相思木",
  "block.minecraft.activator_rail": "觸發路軌",
  "block.minecraft.air": "空氣",
  "block.minecraft.allium": "絨球葱",
  "block.minecraft.amethyst_block": "紫水晶磚",
  "block.minecraft.amethyst_cluster": "紫水晶簇",
  "block.minecraft.ancient_debris": "遠古殘骸",
  "block.minecraft.andesite": "安山巖",
  "block.minecraft.andesite_slab": "安山巖半磚",
  "block.minecraft.andesite_stairs": "安山巖樓梯",
  "block.minecraft.andesite_wall": "安山巖牆",
  "block.minecraft.anvil": "鐵砧",
  "block.minecraft.attached_melon_stem": "連接的西瓜莖",
  "block.minecraft.attached_pumpkin_stem": "連接的南瓜莖",
  "block.minecraft.azalea": "杜鵑叢",
  "block.minecraft.azalea_leaves": "杜鵑樹葉",
  "block.minecraft.azure_bluet": "藍花美耳草",
  "block.minecraft.bamboo": "竹",
  "block.minecraft.bamboo_block": "竹塊",
  "block.minecraft.bamboo_button": "竹按鈕",
  "block.minecraft.bamboo_door": "竹門",
  "block.minecraft.bamboo_fence": "竹欄杆",
  "block.minecraft.bamboo_fence_gate": "竹閘門",
  "block.minecraft.bamboo_hanging_sign": "竹吊牌",
  "block.minecraft.bamboo_mosaic": "竹拼塊",
  "block.minecraft.bamboo_mosaic_slab": "竹拼半磚",
  "block.minecraft.bamboo_mosaic_stairs": "竹拼樓梯",
  "block.minecraft.bamboo_planks": "竹板",
  "block.minecraft.bamboo_pressure_plate": "竹壓力板",
  "block.minecraft.bamboo_sapling": "竹筍",
  "block.minecraft.bamboo_shelf": "竹置物架",
  "block.minecraft.bamboo_sign": "竹指示牌",
  "block.minecraft.bamboo_slab": "竹半磚",
  "block.minecraft.bamboo_stairs": "竹樓梯",
  "block.minecraft.bamboo_trapdoor": "竹地板門",
  "block.minecraft.bamboo_wall_hanging_sign": "牆上的竹吊牌",
  "block.minecraft.bamboo_wall_sign": "牆上的竹指示牌",
  "block.minecraft.banner.base.black": "黑色底",
  "block.minecraft.banner.base.blue": "藍色底",
  "block.minecraft.banner.base.brown": "啡色底",
  "block.minecraft.banner.base.cyan": "青藍色底",
  "block.minecraft.banner.base.gray": "灰色底",
  "block.minecraft.banner.base.green": "綠色底",
  "block.minecraft.banner.base.light_blue": "淺藍色底",
  "block.minecraft.banner.base.light_gray": "淺灰色底",
  "block.minecraft.banner.base.lime": "淺綠色底",
  "block.minecraft.banner.base.magenta": "紫紅色底",
  "block.minecraft.banner.base.orange": "橙色底",
  "block.minecraft.banner.base.pink": "粉紅色底",
  "block.minecraft.banner.base.purple": "紫色底",
  "block.minecraft.banner.base.red": "紅色底",
  "block.minecraft.banner.base.white": "白色底",
  "block.minecraft.banner.base.yellow": "黃色底",
  "block.minecraft.banner.border.black": "黑色邊",
  "block.minecraft.banner.border.blue": "藍色邊",
  "block.minecraft.banner.border.brown": "啡色邊",
  "block.minecraft.banner.border.cyan": "青藍色邊",
  "block.minecraft.banner.border.gray": "灰色邊",
  "block.minecraft.banner.border.green": "綠色邊",
  "block.minecraft.banner.border.light_blue": "淺藍色邊",
  "block.minecraft.banner.border.light_gray": "淺灰色邊",
  "block.minecraft.banner.border.lime": "淺綠色邊",
  "block.minecraft.banner.border.magenta": "紫紅色邊",
  "block.minecraft.banner.border.orange": "橙色邊",
  "block.minecraft.banner.border.pink": "粉紅色邊",
  "block.minecraft.banner.border.purple": "紫色邊",
  "block.minecraft.banner.border.red": "紅色邊",
  "block.minecraft.banner.border.white": "白色邊",
  "block.minecraft.banner.border.yellow": "黃色邊",
  "block.minecraft.banner.bricks.black": "黑色磚牆花紋",
  "block.minecraft.banner.bricks.blue": "藍色磚牆花紋",
  "block.minecraft.banner.bricks.brown": "啡色磚牆花紋",
  "block.minecraft.banner.bricks.cyan": "青藍色磚牆花紋",
  "block.minecraft.banner.bricks.gray": "灰色磚牆花紋",
  "block.minecraft.banner.bricks.green": "綠色磚牆花紋",
  "block.minecraft.banner.bricks.light_blue": "淺藍色磚牆花紋",
  "block.minecraft.banner.bricks.light_gray": "淺灰色磚牆花紋",
  "block.minecraft.banner.bricks.lime": "淺綠色磚牆花紋",
  "block.minecraft.banner.bricks.magenta": "紫紅色磚牆花紋",
  "block.minecraft.banner.bricks.orange": "橙色磚牆花紋",
  "block.minecraft.banner.bricks.pink": "粉紅色磚牆花紋",
  "block.minecraft.banner.bricks.purple": "紫色磚牆花紋",
  "block.minecraft.banner.bricks.red": "紅色磚牆花紋",
  "block.minecraft.banner.bricks.white": "白色磚牆花紋",
  "block.minecraft.banner.bricks.yellow": "黃色磚牆花紋",
  "block.minecraft.banner.circle.black": "黑色圓形",
  "block.minecraft.banner.circle.blue": "藍色圓形",
  "block.minecraft.banner.circle.brown": "啡色圓形",
  "block.minecraft.banner.circle.cyan": "青藍色圓形",
  "block.minecraft.banner.circle.gray": "灰色圓形",
  "block.minecraft.banner.circle.green": "綠色圓形",
  "block.minecraft.banner.circle.light_blue": "淺藍色圓形",
  "block.minecraft.banner.circle.light_gray": "淺灰色圓形",
  "block.minecraft.banner.circle.lime": "淺綠色圓形",
  "block.minecraft.banner.circle.magenta": "紫紅色圓形",
  "block.minecraft.banner.circle.orange": "橙色圓形",
  "block.minecraft.banner.circle.pink": "粉紅色圓形",
  "block.minecraft.banner.circle.purple": "紫色圓形",
  "block.minecraft.banner.circle.red": "紅色圓形",
  "block.minecraft.banner.circle.white": "白色圓形",
  "block.minecraft.banner.circle.yellow": "黃色圓形",
  "block.minecraft.banner.creeper.black": "黑色 Creeper 圖案",
  "block.minecraft.banner.creeper.blue": "藍色 Creeper 圖案",
  "block.minecraft.banner.creeper.brown": "啡色 Creeper 圖案",
  "block.minecraft.banner.creeper.cyan": "青藍色 Creeper 圖案",
  "block.minecraft.banner.creeper.gray": "灰色 Creeper 圖案",
  "block.minecraft.banner.creeper.green": "綠色 Creeper 圖案",
  "block.minecraft.banner.creeper.light_blue": "淺藍色 Creeper 圖案",
  "block.minecraft.banner.creeper.light_gray": "淺灰色 Creeper 圖案",
  "block.minecraft.banner.creeper.lime": "淺綠色 Creeper 圖案",
  "block.minecraft.banner.creeper.magenta": "紫紅色 Creeper 圖案",
  "block.minecraft.banner.creeper.orange": "橙色 Creeper 圖案",
  "block.minecraft.banner.creeper.pink": "粉紅色 Creeper 圖案",
  "block.minecraft.banner.creeper.purple": "紫色 Creeper 圖案",
  "block.minecraft.banner.creeper.red": "紅色 Creeper 圖案",
  "block.minecraft.banner.creeper.white": "白色 Creeper 圖案",
  "block.minecraft.banner.creeper.yellow": "黃色 Creeper 圖案",
  "block.minecraft.banner.cross.black": "黑色對角交叉",
  "block.minecraft.banner.cross.blue": "藍色對角交叉",
  "block.minecraft.banner.cross.brown": "啡色對角交叉",
  "block.minecraft.banner.cross.cyan": "青藍色對角交叉",
  "block.minecraft.banner.cross.gray": "灰色對角交叉",
  "block.minecraft.banner.cross.green": "綠色對角交叉",
  "block.minecraft.banner.cross.light_blue": "淺藍色對角交叉",
  "block.minecraft.banner.cross.light_gray": "淺灰色對角交叉",
  "block.minecraft.banner.cross.lime": "淺綠色對角交叉",
  "block.minecraft.banner.cross.magenta": "紫紅色對角交叉",
  "block.minecraft.banner.cross.orange": "橙色對角交叉",
  "block.minecraft.banner.cross.pink": "粉紅色對角交叉",
  "block.minecraft.banner.cross.purple": "紫色對角交叉",
  "block.minecraft.banner.cross.red": "紅色對角交叉",
  "block.minecraft.banner.cross.white": "白色對角交叉",
  "block.minecraft.banner.cross.yellow": "黃色對角交叉",
  "block.minecraft.banner.curly_border.black": "黑色鋸齒邊",
  "block.minecraft.banner.curly_border.blue": "藍色鋸齒邊",
  "block.minecraft.banner.curly_border.brown": "啡色鋸齒邊",
  "block.minecraft.banner.curly_border.cyan": "青藍色鋸齒邊",
  "block.minecraft.banner.curly_border.gray": "灰色鋸齒邊",
  "block.minecraft.banner.curly_border.green": "綠色鋸齒邊",
  "block.minecraft.banner.curly_border.light_blue": "淺藍色鋸齒邊",
  "block.minecraft.banner.curly_border.light_gray": "淺灰色鋸齒邊",
  "block.minecraft.banner.curly_border.lime": "淺綠色鋸齒邊",
  "block.minecraft.banner.curly_border.magenta": "紫紅色鋸齒邊",
  "block.minecraft.banner.curly_border.orange": "橙色鋸齒邊",
  "block.minecraft.banner.curly_border.pink": "粉紅色鋸齒邊",
  "block.minecraft.banner.curly_border.purple": "紫色鋸齒邊",
  "block.minecraft.banner.curly_border.red": "紅色鋸齒邊",
  "block.minecraft.banner.curly_border.white": "白色鋸齒邊",
  "block.minecraft.banner.curly_border.yellow": "黃色鋸齒邊",
  "block.minecraft.banner.diagonal_left.black": "右上黑色三角",
  "block.minecraft.banner.diagonal_left.blue": "右上藍色三角",
  "block.minecraft.banner.diagonal_left.brown": "右上啡色三角",
  "block.minecraft.banner.diagonal_left.cyan": "右上青藍色三角",
  "block.minecraft.banner.diagonal_left.gray": "右上灰色三角",
  "block.minecraft.banner.diagonal_left.green": "右上綠色三角",
  "block.minecraft.banner.diagonal_left.light_blue": "右上淺藍色三角",
  "block.minecraft.banner.diagonal_left.light_gray": "右上淺灰色三角",
  "block.minecraft.banner.diagonal_left.lime": "右上淺綠色三角",
  "block.minecraft.banner.diagonal_left.magenta": "右上紫紅色三角",
  "block.minecraft.banner.diagonal_left.orange": "右上橙色三角",
  "block.minecraft.banner.diagonal_left.pink": "右上粉紅色三角",
  "block.minecraft.banner.diagonal_left.purple": "右上紫色三角",
  "block.minecraft.banner.diagonal_left.red": "右上紅色三角",
  "block.minecraft.banner.diagonal_left.white": "右上白色三角",
  "block.minecraft.banner.diagonal_left.yellow": "右上黃色三角",
  "block.minecraft.banner.diagonal_right.black": "左上黑色三角",
  "block.minecraft.banner.diagonal_right.blue": "左上藍色三角",
  "block.minecraft.banner.diagonal_right.brown": "左上啡色三角",
  "block.minecraft.banner.diagonal_right.cyan": "左上青藍色三角",
  "block.minecraft.banner.diagonal_right.gray": "左上灰色三角",
  "block.minecraft.banner.diagonal_right.green": "左上綠色三角",
  "block.minecraft.banner.diagonal_right.light_blue": "左上淺藍色三角",
  "block.minecraft.banner.diagonal_right.light_gray": "左上淺灰色三角",
  "block.minecraft.banner.diagonal_right.lime": "左上淺綠色三角",
  "block.minecraft.banner.diagonal_right.magenta": "左上紫紅色三角",
  "block.minecraft.banner.diagonal_right.orange": "左上橙色三角",
  "block.minecraft.banner.diagonal_right.pink": "左上粉紅色三角",
  "block.minecraft.banner.diagonal_right.purple": "左上紫色三角",
  "block.minecraft.banner.diagonal_right.red": "左上紅色三角",
  "block.minecraft.banner.diagonal_right.white": "左上白色三角",
  "block.minecraft.banner.diagonal_right.yellow": "左上黃色三角",
  "block.minecraft.banner.diagonal_up_left.black": "右下黑色三角",
  "block.minecraft.banner.diagonal_up_left.blue": "右下藍色三角",
  "block.minecraft.banner.diagonal_up_left.brown": "右下啡色三角",
  "block.minecraft.banner.diagonal_up_left.cyan": "右下青藍色三角",
  "block.minecraft.banner.diagonal_up_left.gray": "右下灰色三角",
  "block.minecraft.banner.diagonal_up_left.green": "右下綠色三角",
  "block.minecraft.banner.diagonal_up_left.light_blue": "右下淺藍色三角",
  "block.minecraft.banner.diagonal_up_left.light_gray": "右下淺灰色三角",
  "block.minecraft.banner.diagonal_up_left.lime": "右下淺綠色三角",
  "block.minecraft.banner.diagonal_up_left.magenta": "右下紫紅色三角",
  "block.minecraft.banner.diagonal_up_left.orange": "右下橙色三角",
  "block.minecraft.banner.diagonal_up_left.pink": "右下粉紅色三角",
  "block.minecraft.banner.diagonal_up_left.purple": "右下紫色三角",
  "block.minecraft.banner.diagonal_up_left.red": "右下紅色三角",
  "block.minecraft.banner.diagonal_up_left.white": "右下白色三角",
  "block.minecraft.banner.diagonal_up_left.yellow": "右下黃色三角",
  "block.minecraft.banner.diagonal_up_right.black": "左下黑色三角",
  "block.minecraft.banner.diagonal_up_right.blue": "左下藍色三角",
  "block.minecraft.banner.diagonal_up_right.brown": "左下啡色三角",
  "block.minecraft.banner.diagonal_up_right.cyan": "左下青藍色三角",
  "block.minecraft.banner.diagonal_up_right.gray": "左下灰色三角",
  "block.minecraft.banner.diagonal_up_right.green": "左下綠色三角",
  "block.minecraft.banner.diagonal_up_right.light_blue": "左下淺藍色三角",
  "block.minecraft.banner.diagonal_up_right.light_gray": "左下淺灰色三角",
  "block.minecraft.banner.diagonal_up_right.lime": "左下淺綠色三角",
  "block.minecraft.banner.diagonal_up_right.magenta": "左下紫紅色三角",
  "block.minecraft.banner.diagonal_up_right.orange": "左下橙色三角",
  "block.minecraft.banner.diagonal_up_right.pink": "左下粉紅色三角",
  "block.minecraft.banner.diagonal_up_right.purple": "左下紫色三角",
  "block.minecraft.banner.diagonal_up_right.red": "左下紅色三角",
  "block.minecraft.banner.diagonal_up_right.white": "左下白色三角",
  "block.minecraft.banner.diagonal_up_right.yellow": "左下黃色三角",
  "block.minecraft.banner.flow.black": "黑色渦流",
  "block.minecraft.banner.flow.blue": "藍色渦流",
  "block.minecraft.banner.flow.brown": "啡色渦流",
  "block.minecraft.banner.flow.cyan": "青藍色渦流",
  "block.minecraft.banner.flow.gray": "灰色渦流",
  "block.minecraft.banner.flow.green": "綠色渦流",
  "block.minecraft.banner.flow.light_blue": "淺藍色渦流",
  "block.minecraft.banner.flow.light_gray": "淺灰色渦流",
  "block.minecraft.banner.flow.lime": "淺綠色渦流",
  "block.minecraft.banner.flow.magenta": "紫紅色渦流",
  "block.minecraft.banner.flow.orange": "橙色渦流",
  "block.minecraft.banner.flow.pink": "粉紅色渦流",
  "block.minecraft.banner.flow.purple": "紫色渦流",
  "block.minecraft.banner.flow.red": "紅色渦流",
  "block.minecraft.banner.flow.white": "白色渦流",
  "block.minecraft.banner.flow.yellow": "黃色渦流",
  "block.minecraft.banner.flower.black": "黑色花朵圖案",
  "block.minecraft.banner.flower.blue": "藍色花朵圖案",
  "block.minecraft.banner.flower.brown": "啡色花朵圖案",
  "block.minecraft.banner.flower.cyan": "青藍色花朵圖案",
  "block.minecraft.banner.flower.gray": "灰色花朵圖案",
  "block.minecraft.banner.flower.green": "綠色花朵圖案",
  "block.minecraft.banner.flower.light_blue": "淺藍色花朵圖案",
  "block.minecraft.banner.flower.light_gray": "淺灰色花朵圖案",
  "block.minecraft.banner.flower.lime": "淺綠色花朵圖案",
  "block.minecraft.banner.flower.magenta": "紫紅色花朵圖案",
  "block.minecraft.banner.flower.orange": "橙色花朵圖案",
  "block.minecraft.banner.flower.pink": "粉紅色花朵圖案",
  "block.minecraft.banner.flower.purple": "紫色花朵圖案",
  "block.minecraft.banner.flower.red": "紅色花朵圖案",
  "block.minecraft.banner.flower.white": "白色花朵圖案",
  "block.minecraft.banner.flower.yellow": "黃色花朵圖案",
  "block.minecraft.banner.globe.black": "黑色地球",
  "block.minecraft.banner.globe.blue": "藍色地球",
  "block.minecraft.banner.globe.brown": "啡色地球",
  "block.minecraft.banner.globe.cyan": "青藍色地球",
  "block.minecraft.banner.globe.gray": "灰色地球",
  "block.minecraft.banner.globe.green": "綠色地球",
  "block.minecraft.banner.globe.light_blue": "淺藍色地球",
  "block.minecraft.banner.globe.light_gray": "淺灰色地球",
  "block.minecraft.banner.globe.lime": "淺綠色地球",
  "block.minecraft.banner.globe.magenta": "紫紅色地球",
  "block.minecraft.banner.globe.orange": "橙色地球",
  "block.minecraft.banner.globe.pink": "粉紅色地球",
  "block.minecraft.banner.globe.purple": "紫色地球",
  "block.minecraft.banner.globe.red": "紅色地球",
  "block.minecraft.banner.globe.white": "白色地球",
  "block.minecraft.banner.globe.yellow": "黃色地球",
  "block.minecraft.banner.gradient.black": "黑色向下漸淡",
  "block.minecraft.banner.gradient.blue": "藍色向下漸淡",
  "block.minecraft.banner.gradient.brown": "啡色向下漸淡",
  "block.minecraft.banner.gradient.cyan": "青藍色向下漸淡",
  "block.minecraft.banner.gradient.gray": "灰色向下漸淡",
  "block.minecraft.banner.gradient.green": "綠色向下漸淡",
  "block.minecraft.banner.gradient.light_blue": "淺藍色向下漸淡",
  "block.minecraft.banner.gradient.light_gray": "淺灰色向下漸淡",
  "block.minecraft.banner.gradient.lime": "淺綠色向下漸淡",
  "block.minecraft.banner.gradient.magenta": "紫紅色向下漸淡",
  "block.minecraft.banner.gradient.orange": "橙色向下漸淡",
  "block.minecraft.banner.gradient.pink": "粉紅色向下漸淡",
  "block.minecraft.banner.gradient.purple": "紫色向下漸淡",
  "block.minecraft.banner.gradient.red": "紅色向下漸淡",
  "block.minecraft.banner.gradient.white": "白色向下漸淡",
  "block.minecraft.banner.gradient.yellow": "黃色向下漸淡",
  "block.minecraft.banner.gradient_up.black": "黑色向上漸淡",
  "block.minecraft.banner.gradient_up.blue": "藍色向上漸淡",
  "block.minecraft.banner.gradient_up.brown": "啡色向上漸淡",
  "block.minecraft.banner.gradient_up.cyan": "青藍色向上漸淡",
  "block.minecraft.banner.gradient_up.gray": "灰色向上漸淡",
  "block.minecraft.banner.gradient_up.green": "綠色向上漸淡",
  "block.minecraft.banner.gradient_up.light_blue": "淺藍色向上漸淡",
  "block.minecraft.banner.gradient_up.light_gray": "淺灰色向上漸淡",
  "block.minecraft.banner.gradient_up.lime": "淺綠色向上漸淡",
  "block.minecraft.banner.gradient_up.magenta": "紫紅色向上漸淡",
  "block.minecraft.banner.gradient_up.orange": "橙色向上漸淡",
  "block.minecraft.banner.gradient_up.pink": "粉紅色向上漸淡",
  "block.minecraft.banner.gradient_up.purple": "紫色向上漸淡",
  "block.minecraft.banner.gradient_up.red": "紅色向上漸淡",
  "block.minecraft.banner.gradient_up.white": "白色向上漸淡",
  "block.minecraft.banner.gradient_up.yellow": "黃色向上漸淡",
  "block.minecraft.banner.guster.black": "黑色旋風",
  "block.minecraft.banner.guster.blue": "藍色旋風",
  "block.minecraft.banner.guster.brown": "啡色旋風",
  "block.minecraft.banner.guster.cyan": "青藍色旋風",
  "block.minecraft.banner.guster.gray": "灰色旋風",
  "block.minecraft.banner.guster.green": "綠色旋風",
  "block.minecraft.banner.guster.light_blue": "淺藍色旋風",
  "block.minecraft.banner.guster.light_gray": "淺灰色旋風",
  "block.minecraft.banner.guster.lime": "淺綠色旋風",
  "block.minecraft.banner.guster.magenta": "紫紅色旋風",
  "block.minecraft.banner.guster.orange": "橙色旋風",
  "block.minecraft.banner.guster.pink": "粉紅色旋風",
  "block.minecraft.banner.guster.purple": "紫色旋風",
  "block.minecraft.banner.guster.red": "紅色旋風",
  "block.minecraft.banner.guster.white": "白色旋風",
  "block.minecraft.banner.guster.yellow": "黃色旋風",
  "block.minecraft.banner.half_horizontal.black": "頂部黑色方形",
  "block.minecraft.banner.half_horizontal.blue": "頂部藍色方形",
  "block.minecraft.banner.half_horizontal.brown": "頂部啡色方形",
  "block.minecraft.banner.half_horizontal.cyan": "頂部青藍色方形",
  "block.minecraft.banner.half_horizontal.gray": "頂部灰色方形",
  "block.minecraft.banner.half_horizontal.green": "頂部綠色方形",
  "block.minecraft.banner.half_horizontal.light_blue": "頂部淺藍色方形",
  "block.minecraft.banner.half_horizontal.light_gray": "頂部淺灰色方形",
  "block.minecraft.banner.half_horizontal.lime": "頂部淺綠色方形",
  "block.minecraft.banner.half_horizontal.magenta": "頂部紫紅色方形",
  "block.minecraft.banner.half_horizontal.orange": "頂部橙色方形",
  "block.minecraft.banner.half_horizontal.pink": "頂部粉紅色方形",
  "block.minecraft.banner.half_horizontal.purple": "頂部紫色方形",
  "block.minecraft.banner.half_horizontal.red": "頂部紅色方形",
  "block.minecraft.banner.half_horizontal.white": "頂部白色方形",
  "block.minecraft.banner.half_horizontal.yellow": "頂部黃色方形",
  "block.minecraft.banner.half_horizontal_bottom.black": "底部黑色方形",
  "block.minecraft.banner.half_horizontal_bottom.blue": "底部藍色方形",
  "block.minecraft.banner.half_horizontal_bottom.brown": "底部啡色方形",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "底部青藍色方形",
  "block.minecraft.banner.half_horizontal_bottom.gray": "底部灰色方形",
  "block.minecraft.banner.half_horizontal_bottom.green": "底部綠色方形",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "底部淺藍色方形",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "底部淺灰色方形",
  "block.minecraft.banner.half_horizontal_bottom.lime": "底部淺綠色方形",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "底部紫紅色方形",
  "block.minecraft.banner.half_horizontal_bottom.orange": "底部橙色方形",
  "block.minecraft.banner.half_horizontal_bottom.pink": "底部粉紅色方形",
  "block.minecraft.banner.half_horizontal_bottom.purple": "底部紫色方形",
  "block.minecraft.banner.half_horizontal_bottom.red": "底部紅色方形",
  "block.minecraft.banner.half_horizontal_bottom.white": "底部白色方形",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "底部黃色方形",
  "block.minecraft.banner.half_vertical.black": "右側黑色方形",
  "block.minecraft.banner.half_vertical.blue": "右側藍色方形",
  "block.minecraft.banner.half_vertical.brown": "右側啡色方形",
  "block.minecraft.banner.half_vertical.cyan": "右側青藍色方形",
  "block.minecraft.banner.half_vertical.gray": "右側灰色方形",
  "block.minecraft.banner.half_vertical.green": "右側綠色方形",
  "block.minecraft.banner.half_vertical.light_blue": "右側淺藍色方形",
  "block.minecraft.banner.half_vertical.light_gray": "右側淺灰色方形",
  "block.minecraft.banner.half_vertical.lime": "右側淺綠色方形",
  "block.minecraft.banner.half_vertical.magenta": "右側紫紅色方形",
  "block.minecraft.banner.half_vertical.orange": "右側橙色方形",
  "block.minecraft.banner.half_vertical.pink": "右半部分粉紅色填滿",
  "block.minecraft.banner.half_vertical.purple": "右側紫色方形",
  "block.minecraft.banner.half_vertical.red": "右側紅色方形",
  "block.minecraft.banner.half_vertical.white": "右側白色方形",
  "block.minecraft.banner.half_vertical.yellow": "右側黃色方形",
  "block.minecraft.banner.half_vertical_right.black": "左側黑色方形",
  "block.minecraft.banner.half_vertical_right.blue": "左側藍色方形",
  "block.minecraft.banner.half_vertical_right.brown": "左側啡色方形",
  "block.minecraft.banner.half_vertical_right.cyan": "左側青藍色方形",
  "block.minecraft.banner.half_vertical_right.gray": "左側灰色方形",
  "block.minecraft.banner.half_vertical_right.green": "左側綠色方形",
  "block.minecraft.banner.half_vertical_right.light_blue": "左側淺藍色方形",
  "block.minecraft.banner.half_vertical_right.light_gray": "左側淺灰色方形",
  "block.minecraft.banner.half_vertical_right.lime": "左側淺綠色方形",
  "block.minecraft.banner.half_vertical_right.magenta": "左側紫紅色方形",
  "block.minecraft.banner.half_vertical_right.orange": "左側橙色方形",
  "block.minecraft.banner.half_vertical_right.pink": "左側粉紅色方形",
  "block.minecraft.banner.half_vertical_right.purple": "左側紫色方形",
  "block.minecraft.banner.half_vertical_right.red": "左側紅色方形",
  "block.minecraft.banner.half_vertical_right.white": "左側白色方形",
  "block.minecraft.banner.half_vertical_right.yellow": "左側黃色方形",
  "block.minecraft.banner.mojang.black": "黑色 Mojang 標誌",
  "block.minecraft.banner.mojang.blue": "藍色 Mojang 標誌",
  "block.minecraft.banner.mojang.brown": "啡色 Mojang 標誌",
  "block.minecraft.banner.mojang.cyan": "青藍色 Mojang 標誌",
  "block.minecraft.banner.mojang.gray": "灰色 Mojang 標誌",
  "block.minecraft.banner.mojang.green": "綠色 Mojang 標誌",
  "block.minecraft.banner.mojang.light_blue": "淺藍色 Mojang 標誌",
  "block.minecraft.banner.mojang.light_gray": "淺灰色 Mojang 標誌",
  "block.minecraft.banner.mojang.lime": "淺綠色 Mojang 標誌",
  "block.minecraft.banner.mojang.magenta": "紫紅色 Mojang 標誌",
  "block.minecraft.banner.mojang.orange": "橙色 Mojang 標誌",
  "block.minecraft.banner.mojang.pink": "粉紅色 Mojang 標誌",
  "block.minecraft.banner.mojang.purple": "紫色 Mojang 標誌",
  "block.minecraft.banner.mojang.red": "紅色 Mojang 標誌",
  "block.minecraft.banner.mojang.white": "白色 Mojang 標誌",
  "block.minecraft.banner.mojang.yellow": "黃色 Mojang 標誌",
  "block.minecraft.banner.piglin.black": "黑色豬鼻",
  "block.minecraft.banner.piglin.blue": "藍色豬鼻",
  "block.minecraft.banner.piglin.brown": "啡色豬鼻",
  "block.minecraft.banner.piglin.cyan": "青藍色豬鼻",
  "block.minecraft.banner.piglin.gray": "灰色豬鼻",
  "block.minecraft.banner.piglin.green": "綠色豬鼻",
  "block.minecraft.banner.piglin.light_blue": "淺藍色豬鼻",
  "block.minecraft.banner.piglin.light_gray": "淺灰色豬鼻",
  "block.minecraft.banner.piglin.lime": "淺綠色豬鼻",
  "block.minecraft.banner.piglin.magenta": "紫紅色豬鼻",
  "block.minecraft.banner.piglin.orange": "橙色豬鼻",
  "block.minecraft.banner.piglin.pink": "粉紅色豬鼻",
  "block.minecraft.banner.piglin.purple": "紫色豬鼻",
  "block.minecraft.banner.piglin.red": "紅色豬鼻",
  "block.minecraft.banner.piglin.white": "白色豬鼻",
  "block.minecraft.banner.piglin.yellow": "黃色豬鼻",
  "block.minecraft.banner.rhombus.black": "黑色菱形",
  "block.minecraft.banner.rhombus.blue": "藍色菱形",
  "block.minecraft.banner.rhombus.brown": "啡色菱形",
  "block.minecraft.banner.rhombus.cyan": "青藍色菱形",
  "block.minecraft.banner.rhombus.gray": "灰色菱形",
  "block.minecraft.banner.rhombus.green": "綠色菱形",
  "block.minecraft.banner.rhombus.light_blue": "淺藍色菱形",
  "block.minecraft.banner.rhombus.light_gray": "淺灰色菱形",
  "block.minecraft.banner.rhombus.lime": "淺綠色菱形",
  "block.minecraft.banner.rhombus.magenta": "紫紅色菱形",
  "block.minecraft.banner.rhombus.orange": "橙色菱形",
  "block.minecraft.banner.rhombus.pink": "粉紅色菱形",
  "block.minecraft.banner.rhombus.purple": "紫色菱形",
  "block.minecraft.banner.rhombus.red": "紅色菱形",
  "block.minecraft.banner.rhombus.white": "白色菱形",
  "block.minecraft.banner.rhombus.yellow": "黃色菱形",
  "block.minecraft.banner.skull.black": "黑色骷髏骨圖案",
  "block.minecraft.banner.skull.blue": "藍色骷髏骨圖案",
  "block.minecraft.banner.skull.brown": "啡色骷髏骨圖案",
  "block.minecraft.banner.skull.cyan": "青藍色骷髏骨圖案",
  "block.minecraft.banner.skull.gray": "灰色骷髏骨圖案",
  "block.minecraft.banner.skull.green": "綠色骷髏骨圖案",
  "block.minecraft.banner.skull.light_blue": "淺藍色骷髏骨圖案",
  "block.minecraft.banner.skull.light_gray": "淺灰色骷髏骨圖案",
  "block.minecraft.banner.skull.lime": "淺綠色骷髏骨圖案",
  "block.minecraft.banner.skull.magenta": "紫紅色骷髏骨圖案",
  "block.minecraft.banner.skull.orange": "橙色骷髏骨圖案",
  "block.minecraft.banner.skull.pink": "粉紅色骷髏骨圖案",
  "block.minecraft.banner.skull.purple": "紫色骷髏骨圖案",
  "block.minecraft.banner.skull.red": "紅色骷髏骨圖案",
  "block.minecraft.banner.skull.white": "白色骷髏骨圖案",
  "block.minecraft.banner.skull.yellow": "黃色骷髏骨圖案",
  "block.minecraft.banner.small_stripes.black": "黑色豎條紋",
  "block.minecraft.banner.small_stripes.blue": "藍色豎條紋",
  "block.minecraft.banner.small_stripes.brown": "啡色豎條紋",
  "block.minecraft.banner.small_stripes.cyan": "青藍色豎條紋",
  "block.minecraft.banner.small_stripes.gray": "灰色豎條紋",
  "block.minecraft.banner.small_stripes.green": "綠色豎條紋",
  "block.minecraft.banner.small_stripes.light_blue": "淺藍色豎條紋",
  "block.minecraft.banner.small_stripes.light_gray": "淺灰色豎條紋",
  "block.minecraft.banner.small_stripes.lime": "淺綠色豎條紋",
  "block.minecraft.banner.small_stripes.magenta": "紫紅色豎條紋",
  "block.minecraft.banner.small_stripes.orange": "橙色豎條紋",
  "block.minecraft.banner.small_stripes.pink": "粉紅色豎條紋",
  "block.minecraft.banner.small_stripes.purple": "紫色豎條紋",
  "block.minecraft.banner.small_stripes.red": "紅色豎條紋",
  "block.minecraft.banner.small_stripes.white": "白色豎條紋",
  "block.minecraft.banner.small_stripes.yellow": "黃色豎條紋",
  "block.minecraft.banner.square_bottom_left.black": "右下黑色方格",
  "block.minecraft.banner.square_bottom_left.blue": "右下藍色方格",
  "block.minecraft.banner.square_bottom_left.brown": "右下啡色方格",
  "block.minecraft.banner.square_bottom_left.cyan": "右下青藍色方格",
  "block.minecraft.banner.square_bottom_left.gray": "右下灰色方格",
  "block.minecraft.banner.square_bottom_left.green": "右下綠色方格",
  "block.minecraft.banner.square_bottom_left.light_blue": "右下淺藍色方格",
  "block.minecraft.banner.square_bottom_left.light_gray": "右下淺灰色方格",
  "block.minecraft.banner.square_bottom_left.lime": "右下淺綠色方格",
  "block.minecraft.banner.square_bottom_left.magenta": "右下紫紅色方格",
  "block.minecraft.banner.square_bottom_left.orange": "右下橙色方格",
  "block.minecraft.banner.square_bottom_left.pink": "右下粉紅色方格",
  "block.minecraft.banner.square_bottom_left.purple": "右下紫色方格",
  "block.minecraft.banner.square_bottom_left.red": "右下紅色方格",
  "block.minecraft.banner.square_bottom_left.white": "右下白色方格",
  "block.minecraft.banner.square_bottom_left.yellow": "右下黃色方格",
  "block.minecraft.banner.square_bottom_right.black": "左下黑色方格",
  "block.minecraft.banner.square_bottom_right.blue": "左下藍色方格",
  "block.minecraft.banner.square_bottom_right.brown": "左下啡色方格",
  "block.minecraft.banner.square_bottom_right.cyan": "左下青藍色方格",
  "block.minecraft.banner.square_bottom_right.gray": "左下灰色方格",
  "block.minecraft.banner.square_bottom_right.green": "左下綠色方格",
  "block.minecraft.banner.square_bottom_right.light_blue": "左下淺藍色方格",
  "block.minecraft.banner.square_bottom_right.light_gray": "左下淺灰色方格",
  "block.minecraft.banner.square_bottom_right.lime": "左下淺綠色方格",
  "block.minecraft.banner.square_bottom_right.magenta": "左下紫紅色方格",
  "block.minecraft.banner.square_bottom_right.orange": "左下橙色方格",
  "block.minecraft.banner.square_bottom_right.pink": "左下粉紅色方格",
  "block.minecraft.banner.square_bottom_right.purple": "左下紫色方格",
  "block.minecraft.banner.square_bottom_right.red": "左下紅色方格",
  "block.minecraft.banner.square_bottom_right.white": "左下白色方格",
  "block.minecraft.banner.square_bottom_right.yellow": "左下黃色方格",
  "block.minecraft.banner.square_top_left.black": "右上黑色方格",
  "block.minecraft.banner.square_top_left.blue": "右上藍色方格",
  "block.minecraft.banner.square_top_left.brown": "右上啡色方格",
  "block.minecraft.banner.square_top_left.cyan": "右上青藍色方格",
  "block.minecraft.banner.square_top_left.gray": "右上灰色方格",
  "block.minecraft.banner.square_top_left.green": "右上綠色方格",
  "block.minecraft.banner.square_top_left.light_blue": "右上淺藍色方格",
  "block.minecraft.banner.square_top_left.light_gray": "右上淺灰色方格",
  "block.minecraft.banner.square_top_left.lime": "右上淺綠色方格",
  "block.minecraft.banner.square_top_left.magenta": "右上紫紅色方格",
  "block.minecraft.banner.square_top_left.orange": "右上橙色方格",
  "block.minecraft.banner.square_top_left.pink": "右上粉紅色方格",
  "block.minecraft.banner.square_top_left.purple": "右上紫色方格",
  "block.minecraft.banner.square_top_left.red": "右上紅色方格",
  "block.minecraft.banner.square_top_left.white": "右上白色方格",
  "block.minecraft.banner.square_top_left.yellow": "右上黃色方格",
  "block.minecraft.banner.square_top_right.black": "左上黑色方格",
  "block.minecraft.banner.square_top_right.blue": "左上藍色方格",
  "block.minecraft.banner.square_top_right.brown": "左上啡色方格",
  "block.minecraft.banner.square_top_right.cyan": "左上青藍色方格",
  "block.minecraft.banner.square_top_right.gray": "左上灰色方格",
  "block.minecraft.banner.square_top_right.green": "左上綠色方格",
  "block.minecraft.banner.square_top_right.light_blue": "左上淺藍色方格",
  "block.minecraft.banner.square_top_right.light_gray": "左上淺灰色方格",
  "block.minecraft.banner.square_top_right.lime": "左上淺綠色方格",
  "block.minecraft.banner.square_top_right.magenta": "左上紫紅色方格",
  "block.minecraft.banner.square_top_right.orange": "左上橙色方格",
  "block.minecraft.banner.square_top_right.pink": "左上粉紅色方格",
  "block.minecraft.banner.square_top_right.purple": "左上紫色方格",
  "block.minecraft.banner.square_top_right.red": "左上紅色方格",
  "block.minecraft.banner.square_top_right.white": "左上白色方格",
  "block.minecraft.banner.square_top_right.yellow": "左上黃色方格",
  "block.minecraft.banner.straight_cross.black": "黑色十字",
  "block.minecraft.banner.straight_cross.blue": "藍色十字",
  "block.minecraft.banner.straight_cross.brown": "啡色十字",
  "block.minecraft.banner.straight_cross.cyan": "青藍色十字",
  "block.minecraft.banner.straight_cross.gray": "灰色十字",
  "block.minecraft.banner.straight_cross.green": "綠色十字",
  "block.minecraft.banner.straight_cross.light_blue": "淺藍色十字",
  "block.minecraft.banner.straight_cross.light_gray": "淺灰色十字",
  "block.minecraft.banner.straight_cross.lime": "淺綠色十字",
  "block.minecraft.banner.straight_cross.magenta": "紫紅色十字",
  "block.minecraft.banner.straight_cross.orange": "橙色十字",
  "block.minecraft.banner.straight_cross.pink": "粉紅色十字",
  "block.minecraft.banner.straight_cross.purple": "紫色十字",
  "block.minecraft.banner.straight_cross.red": "紅色十字",
  "block.minecraft.banner.straight_cross.white": "白色十字",
  "block.minecraft.banner.straight_cross.yellow": "黃色十字",
  "block.minecraft.banner.stripe_bottom.black": "底部黑色橫條",
  "block.minecraft.banner.stripe_bottom.blue": "底部藍色橫條",
  "block.minecraft.banner.stripe_bottom.brown": "底部啡色橫條",
  "block.minecraft.banner.stripe_bottom.cyan": "底部青藍色橫條",
  "block.minecraft.banner.stripe_bottom.gray": "底部灰色橫條",
  "block.minecraft.banner.stripe_bottom.green": "底部綠色橫條",
  "block.minecraft.banner.stripe_bottom.light_blue": "底部淺藍色橫條",
  "block.minecraft.banner.stripe_bottom.light_gray": "底部淺灰色橫條",
  "block.minecraft.banner.stripe_bottom.lime": "底部淺綠色橫條",
  "block.minecraft.banner.stripe_bottom.magenta": "底部紫紅色橫條",
  "block.minecraft.banner.stripe_bottom.orange": "底部橙色橫條",
  "block.minecraft.banner.stripe_bottom.pink": "底部粉紅色橫條",
  "block.minecraft.banner.stripe_bottom.purple": "底部紫色橫條",
  "block.minecraft.banner.stripe_bottom.red": "底部紅色橫條",
  "block.minecraft.banner.stripe_bottom.white": "底部白色橫條",
  "block.minecraft.banner.stripe_bottom.yellow": "底部黃色橫條",
  "block.minecraft.banner.stripe_center.black": "中間黑色豎條",
  "block.minecraft.banner.stripe_center.blue": "中間藍色豎條",
  "block.minecraft.banner.stripe_center.brown": "中間啡色豎條",
  "block.minecraft.banner.stripe_center.cyan": "中間青藍色豎條",
  "block.minecraft.banner.stripe_center.gray": "中間灰色豎條",
  "block.minecraft.banner.stripe_center.green": "中間綠色豎條",
  "block.minecraft.banner.stripe_center.light_blue": "中間淺藍色豎條",
  "block.minecraft.banner.stripe_center.light_gray": "中間淺灰色豎條",
  "block.minecraft.banner.stripe_center.lime": "中間淺綠色豎條",
  "block.minecraft.banner.stripe_center.magenta": "中間紫紅色豎條",
  "block.minecraft.banner.stripe_center.orange": "中間橙色豎條",
  "block.minecraft.banner.stripe_center.pink": "中間粉紅色豎條",
  "block.minecraft.banner.stripe_center.purple": "中間紫色豎條",
  "block.minecraft.banner.stripe_center.red": "中間紅色豎條",
  "block.minecraft.banner.stripe_center.white": "中間白色豎條",
  "block.minecraft.banner.stripe_center.yellow": "中間黃色豎條",
  "block.minecraft.banner.stripe_downleft.black": "左側黑色斜條",
  "block.minecraft.banner.stripe_downleft.blue": "左側藍色斜條",
  "block.minecraft.banner.stripe_downleft.brown": "左側啡色斜條",
  "block.minecraft.banner.stripe_downleft.cyan": "左側青藍色斜條",
  "block.minecraft.banner.stripe_downleft.gray": "左側灰色斜條",
  "block.minecraft.banner.stripe_downleft.green": "左側綠色斜條",
  "block.minecraft.banner.stripe_downleft.light_blue": "左側淺藍色斜條",
  "block.minecraft.banner.stripe_downleft.light_gray": "左側淡灰色斜條",
  "block.minecraft.banner.stripe_downleft.lime": "左側淺綠色斜條",
  "block.minecraft.banner.stripe_downleft.magenta": "左側紫紅色斜條",
  "block.minecraft.banner.stripe_downleft.orange": "左側橙色斜條",
  "block.minecraft.banner.stripe_downleft.pink": "左側粉紅色斜條",
  "block.minecraft.banner.stripe_downleft.purple": "左側紫色斜條",
  "block.minecraft.banner.stripe_downleft.red": "左側紅色斜條",
  "block.minecraft.banner.stripe_downleft.white": "左側白色斜條",
  "block.minecraft.banner.stripe_downleft.yellow": "左側黃色斜條",
  "block.minecraft.banner.stripe_downright.black": "右側黑色斜條",
  "block.minecraft.banner.stripe_downright.blue": "右側藍色斜條",
  "block.minecraft.banner.stripe_downright.brown": "右側啡色斜條",
  "block.minecraft.banner.stripe_downright.cyan": "右側青藍色斜條",
  "block.minecraft.banner.stripe_downright.gray": "右側灰色斜條",
  "block.minecraft.banner.stripe_downright.green": "右側綠色斜條",
  "block.minecraft.banner.stripe_downright.light_blue": "右側淺藍色斜條",
  "block.minecraft.banner.stripe_downright.light_gray": "右側淺灰色斜條",
  "block.minecraft.banner.stripe_downright.lime": "右側淺綠色斜條",
  "block.minecraft.banner.stripe_downright.magenta": "右側紫紅色斜條",
  "block.minecraft.banner.stripe_downright.orange": "右側橙色斜條",
  "block.minecraft.banner.stripe_downright.pink": "右側粉紅色斜條",
  "block.minecraft.banner.stripe_downright.purple": "右側紫色斜條",
  "block.minecraft.banner.stripe_downright.red": "右側紅色斜條",
  "block.minecraft.banner.stripe_downright.white": "右側白色斜條",
  "block.minecraft.banner.stripe_downright.yellow": "右側黃色斜條",
  "block.minecraft.banner.stripe_left.black": "右側黑色豎條",
  "block.minecraft.banner.stripe_left.blue": "右側藍色豎條",
  "block.minecraft.banner.stripe_left.brown": "右側啡色豎條",
  "block.minecraft.banner.stripe_left.cyan": "右側青藍色豎條",
  "block.minecraft.banner.stripe_left.gray": "右側灰色豎條",
  "block.minecraft.banner.stripe_left.green": "右側綠色豎條",
  "block.minecraft.banner.stripe_left.light_blue": "右側淺藍色豎條",
  "block.minecraft.banner.stripe_left.light_gray": "右側淺灰色豎條",
  "block.minecraft.banner.stripe_left.lime": "右側淺綠色豎條",
  "block.minecraft.banner.stripe_left.magenta": "右側紫紅色豎條",
  "block.minecraft.banner.stripe_left.orange": "右側橙色豎條",
  "block.minecraft.banner.stripe_left.pink": "右側粉紅色豎條",
  "block.minecraft.banner.stripe_left.purple": "右側紫色豎條",
  "block.minecraft.banner.stripe_left.red": "右側紅色豎條",
  "block.minecraft.banner.stripe_left.white": "右側白色豎條",
  "block.minecraft.banner.stripe_left.yellow": "右側黃色豎條",
  "block.minecraft.banner.stripe_middle.black": "中間黑色橫條",
  "block.minecraft.banner.stripe_middle.blue": "中間藍色橫條",
  "block.minecraft.banner.stripe_middle.brown": "中間啡色橫條",
  "block.minecraft.banner.stripe_middle.cyan": "中間青色橫條",
  "block.minecraft.banner.stripe_middle.gray": "中間灰色橫條",
  "block.minecraft.banner.stripe_middle.green": "中間綠色橫條",
  "block.minecraft.banner.stripe_middle.light_blue": "中間淺藍色橫條",
  "block.minecraft.banner.stripe_middle.light_gray": "中間淺灰色橫條",
  "block.minecraft.banner.stripe_middle.lime": "中間淺綠色橫條",
  "block.minecraft.banner.stripe_middle.magenta": "中間紫紅色橫條",
  "block.minecraft.banner.stripe_middle.orange": "中間橙色橫條",
  "block.minecraft.banner.stripe_middle.pink": "中間粉紅色橫條",
  "block.minecraft.banner.stripe_middle.purple": "中間紫色橫條",
  "block.minecraft.banner.stripe_middle.red": "中間紅色橫條",
  "block.minecraft.banner.stripe_middle.white": "中間白色橫條",
  "block.minecraft.banner.stripe_middle.yellow": "中間黃色橫條",
  "block.minecraft.banner.stripe_right.black": "左側黑色豎條",
  "block.minecraft.banner.stripe_right.blue": "左側藍色豎條",
  "block.minecraft.banner.stripe_right.brown": "左側啡色豎條",
  "block.minecraft.banner.stripe_right.cyan": "左側青藍色豎條",
  "block.minecraft.banner.stripe_right.gray": "左側灰色豎條",
  "block.minecraft.banner.stripe_right.green": "左側綠色豎條",
  "block.minecraft.banner.stripe_right.light_blue": "左側淺藍色豎條",
  "block.minecraft.banner.stripe_right.light_gray": "左側淺灰色豎條",
  "block.minecraft.banner.stripe_right.lime": "左側淺綠色豎條",
  "block.minecraft.banner.stripe_right.magenta": "左側紫紅色豎條",
  "block.minecraft.banner.stripe_right.orange": "左側橙色豎條",
  "block.minecraft.banner.stripe_right.pink": "左側粉紅色豎條",
  "block.minecraft.banner.stripe_right.purple": "左側紫色豎條",
  "block.minecraft.banner.stripe_right.red": "左側紅色豎條",
  "block.minecraft.banner.stripe_right.white": "左側白色豎條",
  "block.minecraft.banner.stripe_right.yellow": "左側黃色豎條",
  "block.minecraft.banner.stripe_top.black": "頂部黑色橫條",
  "block.minecraft.banner.stripe_top.blue": "頂部藍色橫條",
  "block.minecraft.banner.stripe_top.brown": "頂部啡色橫條",
  "block.minecraft.banner.stripe_top.cyan": "頂部青藍色橫條",
  "block.minecraft.banner.stripe_top.gray": "頂部灰色橫條",
  "block.minecraft.banner.stripe_top.green": "頂部綠色橫條",
  "block.minecraft.banner.stripe_top.light_blue": "頂部淺藍色橫條",
  "block.minecraft.banner.stripe_top.light_gray": "頂部淺灰色橫條",
  "block.minecraft.banner.stripe_top.lime": "頂部淺綠色橫條",
  "block.minecraft.banner.stripe_top.magenta": "頂部紫紅色橫條",
  "block.minecraft.banner.stripe_top.orange": "頂部橙色橫條",
  "block.minecraft.banner.stripe_top.pink": "頂部粉紅色橫條",
  "block.minecraft.banner.stripe_top.purple": "頂部紫色橫條",
  "block.minecraft.banner.stripe_top.red": "頂部紅色橫條",
  "block.minecraft.banner.stripe_top.white": "頂部白色橫條",
  "block.minecraft.banner.stripe_top.yellow": "頂部黃色橫條",
  "block.minecraft.banner.triangle_bottom.black": "底部黑色三角",
  "block.minecraft.banner.triangle_bottom.blue": "底部藍色三角",
  "block.minecraft.banner.triangle_bottom.brown": "底部啡色三角",
  "block.minecraft.banner.triangle_bottom.cyan": "底部青藍色三角",
  "block.minecraft.banner.triangle_bottom.gray": "底部灰色三角",
  "block.minecraft.banner.triangle_bottom.green": "底部綠色三角",
  "block.minecraft.banner.triangle_bottom.light_blue": "底部淺藍色三角",
  "block.minecraft.banner.triangle_bottom.light_gray": "底部淺灰色三角",
  "block.minecraft.banner.triangle_bottom.lime": "底部淺綠色三角",
  "block.minecraft.banner.triangle_bottom.magenta": "底部紫紅色三角",
  "block.minecraft.banner.triangle_bottom.orange": "底部橙色三角",
  "block.minecraft.banner.triangle_bottom.pink": "底部粉紅色三角",
  "block.minecraft.banner.triangle_bottom.purple": "底部紫色三角",
  "block.minecraft.banner.triangle_bottom.red": "底部紅色三角",
  "block.minecraft.banner.triangle_bottom.white": "底部白色三角",
  "block.minecraft.banner.triangle_bottom.yellow": "底部黃色三角",
  "block.minecraft.banner.triangle_top.black": "頂部黑色三角",
  "block.minecraft.banner.triangle_top.blue": "頂部藍色三角",
  "block.minecraft.banner.triangle_top.brown": "頂部啡色三角",
  "block.minecraft.banner.triangle_top.cyan": "頂部青藍色三角",
  "block.minecraft.banner.triangle_top.gray": "頂部灰色三角",
  "block.minecraft.banner.triangle_top.green": "頂部綠色三角",
  "block.minecraft.banner.triangle_top.light_blue": "頂部淺藍色三角",
  "block.minecraft.banner.triangle_top.light_gray": "頂部淺灰色三角",
  "block.minecraft.banner.triangle_top.lime": "頂部淺綠色三角",
  "block.minecraft.banner.triangle_top.magenta": "頂部紫紅色三角",
  "block.minecraft.banner.triangle_top.orange": "頂部橙色三角",
  "block.minecraft.banner.triangle_top.pink": "頂部粉紅色三角",
  "block.minecraft.banner.triangle_top.purple": "頂部紫色三角",
  "block.minecraft.banner.triangle_top.red": "頂部紅色三角",
  "block.minecraft.banner.triangle_top.white": "頂部白色三角",
  "block.minecraft.banner.triangle_top.yellow": "頂部黃色三角",
  "block.minecraft.banner.triangles_bottom.black": "底部黑色鋸齒",
  "block.minecraft.banner.triangles_bottom.blue": "底部藍色鋸齒",
  "block.minecraft.banner.triangles_bottom.brown": "底部啡色鋸齒",
  "block.minecraft.banner.triangles_bottom.cyan": "底部青藍色鋸齒",
  "block.minecraft.banner.triangles_bottom.gray": "底部灰色鋸齒",
  "block.minecraft.banner.triangles_bottom.green": "底部綠色鋸齒",
  "block.minecraft.banner.triangles_bottom.light_blue": "底部淺藍色鋸齒",
  "block.minecraft.banner.triangles_bottom.light_gray": "底部淺灰色鋸齒",
  "block.minecraft.banner.triangles_bottom.lime": "底部淺綠色鋸齒",
  "block.minecraft.banner.triangles_bottom.magenta": "底部紫紅色鋸齒",
  "block.minecraft.banner.triangles_bottom.orange": "底部橙色鋸齒",
  "block.minecraft.banner.triangles_bottom.pink": "底部粉紅色鋸齒",
  "block.minecraft.banner.triangles_bottom.purple": "底部紫色鋸齒",
  "block.minecraft.banner.triangles_bottom.red": "底部紅色鋸齒",
  "block.minecraft.banner.triangles_bottom.white": "底部白色鋸齒",
  "block.minecraft.banner.triangles_bottom.yellow": "底部黃色鋸齒",
  "block.minecraft.banner.triangles_top.black": "頂部黑色鋸齒",
  "block.minecraft.banner.triangles_top.blue": "頂部藍色鋸齒",
  "block.minecraft.banner.triangles_top.brown": "頂部啡色鋸齒",
  "block.minecraft.banner.triangles_top.cyan": "頂部青藍色鋸齒",
  "block.minecraft.banner.triangles_top.gray": "頂部灰色鋸齒",
  "block.minecraft.banner.triangles_top.green": "頂部綠色鋸齒",
  "block.minecraft.banner.triangles_top.light_blue": "頂部淺藍色鋸齒",
  "block.minecraft.banner.triangles_top.light_gray": "頂部淺灰色鋸齒",
  "block.minecraft.banner.triangles_top.lime": "頂部淺綠色鋸齒",
  "block.minecraft.banner.triangles_top.magenta": "頂部紫紅色鋸齒",
  "block.minecraft.banner.triangles_top.orange": "頂部橙色鋸齒",
  "block.minecraft.banner.triangles_top.pink": "頂部粉紅色鋸齒",
  "block.minecraft.banner.triangles_top.purple": "頂部紫色鋸齒",
  "block.minecraft.banner.triangles_top.red": "頂部紅色鋸齒",
  "block.minecraft.banner.triangles_top.white": "頂部白色鋸齒",
  "block.minecraft.banner.triangles_top.yellow": "頂部黃色鋸齒",
  "block.minecraft.barrel": "木桶",
  "block.minecraft.barrier": "屏障",
  "block.minecraft.basalt": "玄武巖",
  "block.minecraft.beacon": "燈標",
  "block.minecraft.beacon.primary": "主要效果",
  "block.minecraft.beacon.secondary": "次要效果",
  "block.minecraft.bed.no_sleep": "你僅可於夜晚或者雷暴時入睡",
  "block.minecraft.bed.not_safe": "你現時無法休息，周圍有怪物遊蕩",
  "block.minecraft.bed.obstructed": "牀受到阻擋",
  "block.minecraft.bed.occupied": "牀已被佔用",
  "block.minecraft.bed.too_far_away": "你現時無法休息，牀距離過遠",
  "block.minecraft.bedrock": "基巖",
  "block.minecraft.bee_nest": "蜂巢",
  "block.minecraft.beehive": "蜂箱",
  "block.minecraft.beetroots": "紅菜頭",
  "block.minecraft.bell": "鐘",
  "block.minecraft.big_dripleaf": "大懸葉草",
  "block.minecraft.big_dripleaf_stem": "大懸葉草葉莖",
  "block.minecraft.birch_button": "樺木按鈕",
  "block.minecraft.birch_door": "樺木門",
  "block.minecraft.birch_fence": "樺木欄杆",
  "block.minecraft.birch_fence_gate": "樺木閘門",
  "block.minecraft.birch_hanging_sign": "樺木吊牌",
  "block.minecraft.birch_leaves": "樺木樹葉",
  "block.minecraft.birch_log": "樺木原木",
  "block.minecraft.birch_planks": "樺木板",
  "block.minecraft.birch_pressure_plate": "樺木壓力板",
  "block.minecraft.birch_sapling": "樺木樹苗",
  "block.minecraft.birch_shelf": "樺木置物架",
  "block.minecraft.birch_sign": "樺木指示牌",
  "block.minecraft.birch_slab": "樺木半磚",
  "block.minecraft.birch_stairs": "樺木樓梯",
  "block.minecraft.birch_trapdoor": "樺木地板門",
  "block.minecraft.birch_wall_hanging_sign": "牆上的樺木吊牌",
  "block.minecraft.birch_wall_sign": "牆上的樺木指示牌",
  "block.minecraft.birch_wood": "樺木",
  "block.minecraft.black_banner": "黑色橫額",
  "block.minecraft.black_bed": "黑色牀",
  "block.minecraft.black_candle": "黑色蠟燭",
  "block.minecraft.black_candle_cake": "插上黑色蠟燭的蛋糕",
  "block.minecraft.black_carpet": "黑色地氈",
  "block.minecraft.black_concrete": "黑色混凝土",
  "block.minecraft.black_concrete_powder": "黑色混凝土粉末",
  "block.minecraft.black_glazed_terracotta": "黑色釉陶",
  "block.minecraft.black_shulker_box": "黑色界伏盒",
  "block.minecraft.black_stained_glass": "黑色染色玻璃",
  "block.minecraft.black_stained_glass_pane": "黑色染色玻璃片",
  "block.minecraft.black_terracotta": "黑色陶瓦",
  "block.minecraft.black_wool": "黑色羊毛",
  "block.minecraft.blackstone": "黑石",
  "block.minecraft.blackstone_slab": "黑石半磚",
  "block.minecraft.blackstone_stairs": "黑石樓梯",
  "block.minecraft.blackstone_wall": "黑石牆",
  "block.minecraft.blast_furnace": "高爐",
  "block.minecraft.blue_banner": "藍色橫額",
  "block.minecraft.blue_bed": "藍色牀",
  "block.minecraft.blue_candle": "藍色蠟燭",
  "block.minecraft.blue_candle_cake": "插上藍色蠟燭的蛋糕",
  "block.minecraft.blue_carpet": "藍色地氈",
  "block.minecraft.blue_concrete": "藍色混凝土",
  "block.minecraft.blue_concrete_powder": "藍色混凝土粉末",
  "block.minecraft.blue_glazed_terracotta": "藍色釉陶",
  "block.minecraft.blue_ice": "藍冰",
  "block.minecraft.blue_orchid": "蘭花",
  "block.minecraft.blue_shulker_box": "藍色界伏盒",
  "block.minecraft.blue_stained_glass": "藍色染色玻璃",
  "block.minecraft.blue_stained_glass_pane": "藍色染色玻璃片",
  "block.minecraft.blue_terracotta": "藍色陶瓦",
  "block.minecraft.blue_wool": "藍色羊毛",
  "block.minecraft.bone_block": "骨塊",
  "block.minecraft.bookshelf": "書櫃",
  "block.minecraft.brain_coral": "腦珊瑚",
  "block.minecraft.brain_coral_block": "腦珊瑚方塊",
  "block.minecraft.brain_coral_fan": "扇狀腦珊瑚",
  "block.minecraft.brain_coral_wall_fan": "牆上的扇狀腦珊瑚",
  "block.minecraft.brewing_stand": "釀造台",
  "block.minecraft.brick_slab": "紅磚半磚",
  "block.minecraft.brick_stairs": "紅磚樓梯",
  "block.minecraft.brick_wall": "紅磚牆",
  "block.minecraft.bricks": "紅磚",
  "block.minecraft.brown_banner": "啡色橫額",
  "block.minecraft.brown_bed": "啡色牀",
  "block.minecraft.brown_candle": "啡色蠟燭",
  "block.minecraft.brown_candle_cake": "插上啡色蠟燭的蛋糕",
  "block.minecraft.brown_carpet": "啡色地氈",
  "block.minecraft.brown_concrete": "啡色混凝土",
  "block.minecraft.brown_concrete_powder": "啡色混凝土粉末",
  "block.minecraft.brown_glazed_terracotta": "啡色釉陶",
  "block.minecraft.brown_mushroom": "啡色蘑菇",
  "block.minecraft.brown_mushroom_block": "啡色蘑菇方塊",
  "block.minecraft.brown_shulker_box": "啡色界伏盒",
  "block.minecraft.brown_stained_glass": "啡色染色玻璃",
  "block.minecraft.brown_stained_glass_pane": "啡色染色玻璃片",
  "block.minecraft.brown_terracotta": "啡色陶瓦",
  "block.minecraft.brown_wool": "啡色羊毛",
  "block.minecraft.bubble_column": "氣泡柱",
  "block.minecraft.bubble_coral": "氣泡珊瑚",
  "block.minecraft.bubble_coral_block": "氣泡珊瑚方塊",
  "block.minecraft.bubble_coral_fan": "扇狀氣泡珊瑚",
  "block.minecraft.bubble_coral_wall_fan": "牆上的扇狀氣泡珊瑚",
  "block.minecraft.budding_amethyst": "紫水晶母巖",
  "block.minecraft.bush": "灌木叢",
  "block.minecraft.cactus": "仙人掌",
  "block.minecraft.cactus_flower": "仙人掌花",
  "block.minecraft.cake": "蛋糕",
  "block.minecraft.calcite": "方解石",
  "block.minecraft.calibrated_sculk_sensor": "校準沉靈傳感器",
  "block.minecraft.campfire": "營火",
  "block.minecraft.candle": "蠟燭",
  "block.minecraft.candle_cake": "插上蠟燭的蛋糕",
  "block.minecraft.carrots": "紅蘿蔔",
  "block.minecraft.cartography_table": "製圖台",
  "block.minecraft.carved_pumpkin": "雕刻南瓜",
  "block.minecraft.cauldron": "鍋",
  "block.minecraft.cave_air": "洞穴空氣",
  "block.minecraft.cave_vines": "洞穴藤蔓",
  "block.minecraft.cave_vines_plant": "洞穴藤蔓植株",
  "block.minecraft.chain": "鐵鏈",
  "block.minecraft.chain_command_block": "連環型命令方塊",
  "block.minecraft.cherry_button": "櫻花木按鈕",
  "block.minecraft.cherry_door": "櫻花木門",
  "block.minecraft.cherry_fence": "櫻花木欄杆",
  "block.minecraft.cherry_fence_gate": "櫻花木閘門",
  "block.minecraft.cherry_hanging_sign": "櫻花木吊牌",
  "block.minecraft.cherry_leaves": "櫻花樹葉",
  "block.minecraft.cherry_log": "櫻花原木",
  "block.minecraft.cherry_planks": "櫻花木板",
  "block.minecraft.cherry_pressure_plate": "櫻花木壓力板",
  "block.minecraft.cherry_sapling": "櫻花樹苗",
  "block.minecraft.cherry_shelf": "櫻花木置物架",
  "block.minecraft.cherry_sign": "櫻花木指示牌",
  "block.minecraft.cherry_slab": "櫻花木半磚",
  "block.minecraft.cherry_stairs": "櫻花木樓梯",
  "block.minecraft.cherry_trapdoor": "櫻花木地板門",
  "block.minecraft.cherry_wall_hanging_sign": "牆上的櫻花木吊牌",
  "block.minecraft.cherry_wall_sign": "牆上的櫻花木指示牌",
  "block.minecraft.cherry_wood": "櫻花木",
  "block.minecraft.chest": "儲物箱",
  "block.minecraft.chipped_anvil": "開裂的鐵砧",
  "block.minecraft.chiseled_bookshelf": "浮雕書櫃",
  "block.minecraft.chiseled_copper": "浮雕銅磚",
  "block.minecraft.chiseled_deepslate": "浮雕深板巖",
  "block.minecraft.chiseled_nether_bricks": "浮雕地獄磚",
  "block.minecraft.chiseled_polished_blackstone": "浮雕拋光黑石",
  "block.minecraft.chiseled_quartz_block": "浮雕石英磚",
  "block.minecraft.chiseled_red_sandstone": "浮雕紅砂巖",
  "block.minecraft.chiseled_resin_bricks": "浮雕樹脂磚",
  "block.minecraft.chiseled_sandstone": "浮雕砂巖",
  "block.minecraft.chiseled_stone_bricks": "浮雕石磚",
  "block.minecraft.chiseled_tuff": "浮雕凝灰巖",
  "block.minecraft.chiseled_tuff_bricks": "浮雕凝灰巖磚",
  "block.minecraft.chorus_flower": "歌萊花",
  "block.minecraft.chorus_plant": "歌萊枝",
  "block.minecraft.clay": "黏土",
  "block.minecraft.closed_eyeblossom": "閉合的眼眸花",
  "block.minecraft.coal_block": "煤炭磚",
  "block.minecraft.coal_ore": "煤礦",
  "block.minecraft.coarse_dirt": "粗泥",
  "block.minecraft.cobbled_deepslate": "深板巖碎石",
  "block.minecraft.cobbled_deepslate_slab": "深板巖碎石半磚",
  "block.minecraft.cobbled_deepslate_stairs": "深板巖碎石樓梯",
  "block.minecraft.cobbled_deepslate_wall": "深板巖碎石牆",
  "block.minecraft.cobblestone": "碎石",
  "block.minecraft.cobblestone_slab": "碎石半磚",
  "block.minecraft.cobblestone_stairs": "碎石樓梯",
  "block.minecraft.cobblestone_wall": "碎石牆",
  "block.minecraft.cobweb": "蜘蛛網",
  "block.minecraft.cocoa": "可可果",
  "block.minecraft.command_block": "命令方塊",
  "block.minecraft.comparator": "紅石比較器",
  "block.minecraft.composter": "堆肥桶",
  "block.minecraft.conduit": "海靈核心",
  "block.minecraft.copper_bars": "銅欄杆",
  "block.minecraft.copper_block": "銅磚",
  "block.minecraft.copper_bulb": "銅燈",
  "block.minecraft.copper_chain": "銅鏈",
  "block.minecraft.copper_chest": "銅儲物箱",
  "block.minecraft.copper_door": "銅門",
  "block.minecraft.copper_golem_statue": "銅人雕像",
  "block.minecraft.copper_grate": "銅網格",
  "block.minecraft.copper_lantern": "銅燈籠",
  "block.minecraft.copper_ore": "銅礦",
  "block.minecraft.copper_torch": "銅火炬",
  "block.minecraft.copper_trapdoor": "銅地板門",
  "block.minecraft.copper_wall_torch": "牆上的銅火炬",
  "block.minecraft.cornflower": "矢車菊",
  "block.minecraft.cracked_deepslate_bricks": "裂紋深板巖磚",
  "block.minecraft.cracked_deepslate_tiles": "裂紋深板巖瓦",
  "block.minecraft.cracked_nether_bricks": "裂紋地獄磚",
  "block.minecraft.cracked_polished_blackstone_bricks": "裂紋拋光黑石磚",
  "block.minecraft.cracked_stone_bricks": "裂紋石磚",
  "block.minecraft.crafter": "合成器",
  "block.minecraft.crafting_table": "工作台",
  "block.minecraft.creaking_heart": "異響之心",
  "block.minecraft.creeper_head": "Creeper 頭顱",
  "block.minecraft.creeper_wall_head": "牆上的 Creeper 頭顱",
  "block.minecraft.crimson_button": "猩紅菌木按鈕",
  "block.minecraft.crimson_door": "猩紅菌木門",
  "block.minecraft.crimson_fence": "猩紅菌木欄杆",
  "block.minecraft.crimson_fence_gate": "猩紅菌木閘門",
  "block.minecraft.crimson_fungus": "猩紅菌菇",
  "block.minecraft.crimson_hanging_sign": "猩紅菌木吊牌",
  "block.minecraft.crimson_hyphae": "猩紅菌絲體",
  "block.minecraft.crimson_nylium": "猩紅菌絲石",
  "block.minecraft.crimson_planks": "猩紅菌木板",
  "block.minecraft.crimson_pressure_plate": "猩紅菌木壓力板",
  "block.minecraft.crimson_roots": "猩紅菌根",
  "block.minecraft.crimson_shelf": "猩紅菌木置物架",
  "block.minecraft.crimson_sign": "猩紅菌木指示牌",
  "block.minecraft.crimson_slab": "猩紅菌木半磚",
  "block.minecraft.crimson_stairs": "猩紅菌木樓梯",
  "block.minecraft.crimson_stem": "猩紅菌柄",
  "block.minecraft.crimson_trapdoor": "猩紅菌木地板門",
  "block.minecraft.crimson_wall_hanging_sign": "牆上的猩紅菌木吊牌",
  "block.minecraft.crimson_wall_sign": "牆上的猩紅菌木指示牌",
  "block.minecraft.crying_obsidian": "哭曜石",
  "block.minecraft.cut_copper": "切製銅磚",
  "block.minecraft.cut_copper_slab": "切製銅半磚",
  "block.minecraft.cut_copper_stairs": "切製銅樓梯",
  "block.minecraft.cut_red_sandstone": "切製紅砂巖",
  "block.minecraft.cut_red_sandstone_slab": "切製紅砂巖半磚",
  "block.minecraft.cut_sandstone": "切製砂巖",
  "block.minecraft.cut_sandstone_slab": "切製砂巖半磚",
  "block.minecraft.cyan_banner": "青藍色橫額",
  "block.minecraft.cyan_bed": "青藍色牀",
  "block.minecraft.cyan_candle": "青藍色蠟燭",
  "block.minecraft.cyan_candle_cake": "插上青藍色蠟燭的蛋糕",
  "block.minecraft.cyan_carpet": "青藍色地氈",
  "block.minecraft.cyan_concrete": "青藍色混凝土",
  "block.minecraft.cyan_concrete_powder": "青藍色混凝土粉末",
  "block.minecraft.cyan_glazed_terracotta": "青藍色釉陶",
  "block.minecraft.cyan_shulker_box": "青藍色界伏盒",
  "block.minecraft.cyan_stained_glass": "青藍色染色玻璃",
  "block.minecraft.cyan_stained_glass_pane": "青藍色染色玻璃片",
  "block.minecraft.cyan_terracotta": "青藍色陶瓦",
  "block.minecraft.cyan_wool": "青藍色羊毛",
  "block.minecraft.damaged_anvil": "破損的鐵砧",
  "block.minecraft.dandelion": "蒲公英",
  "block.minecraft.dark_oak_button": "黑橡木按鈕",
  "block.minecraft.dark_oak_door": "黑橡木門",
  "block.minecraft.dark_oak_fence": "黑橡木欄杆",
  "block.minecraft.dark_oak_fence_gate": "黑橡木閘門",
  "block.minecraft.dark_oak_hanging_sign": "黑橡木吊牌",
  "block.minecraft.dark_oak_leaves": "黑橡木樹葉",
  "block.minecraft.dark_oak_log": "黑橡木原木",
  "block.minecraft.dark_oak_planks": "黑橡木板",
  "block.minecraft.dark_oak_pressure_plate": "黑橡木壓力板",
  "block.minecraft.dark_oak_sapling": "黑橡木樹苗",
  "block.minecraft.dark_oak_shelf": "黑橡木置物架",
  "block.minecraft.dark_oak_sign": "黑橡木指示牌",
  "block.minecraft.dark_oak_slab": "黑橡木半磚",
  "block.minecraft.dark_oak_stairs": "黑橡木樓梯",
  "block.minecraft.dark_oak_trapdoor": "黑橡木地板門",
  "block.minecraft.dark_oak_wall_hanging_sign": "牆上的黑橡木吊牌",
  "block.minecraft.dark_oak_wall_sign": "牆上的黑橡木指示牌",
  "block.minecraft.dark_oak_wood": "黑橡木",
  "block.minecraft.dark_prismarine": "暗海磷石",
  "block.minecraft.dark_prismarine_slab": "暗海磷石半磚",
  "block.minecraft.dark_prismarine_stairs": "暗海磷石樓梯",
  "block.minecraft.daylight_detector": "日光感測器",
  "block.minecraft.dead_brain_coral": "死亡腦珊瑚",
  "block.minecraft.dead_brain_coral_block": "死亡腦珊瑚方塊",
  "block.minecraft.dead_brain_coral_fan": "死亡扇狀腦珊瑚",
  "block.minecraft.dead_brain_coral_wall_fan": "牆上的死亡扇狀腦珊瑚",
  "block.minecraft.dead_bubble_coral": "死亡氣泡珊瑚",
  "block.minecraft.dead_bubble_coral_block": "死亡氣泡珊瑚方塊",
  "block.minecraft.dead_bubble_coral_fan": "死亡扇狀氣泡珊瑚",
  "block.minecraft.dead_bubble_coral_wall_fan": "牆上的死亡扇狀氣泡珊瑚",
  "block.minecraft.dead_bush": "死灌木",
  "block.minecraft.dead_fire_coral": "死亡火珊瑚",
  "block.minecraft.dead_fire_coral_block": "死亡火珊瑚方塊",
  "block.minecraft.dead_fire_coral_fan": "死亡扇狀火珊瑚",
  "block.minecraft.dead_fire_coral_wall_fan": "牆上的死亡扇狀火珊瑚",
  "block.minecraft.dead_horn_coral": "死亡角珊瑚",
  "block.minecraft.dead_horn_coral_block": "死亡角珊瑚方塊",
  "block.minecraft.dead_horn_coral_fan": "死亡扇狀角珊瑚",
  "block.minecraft.dead_horn_coral_wall_fan": "牆上的死亡扇狀角珊瑚",
  "block.minecraft.dead_tube_coral": "死亡管珊瑚",
  "block.minecraft.dead_tube_coral_block": "死亡管珊瑚方塊",
  "block.minecraft.dead_tube_coral_fan": "死亡扇狀管珊瑚",
  "block.minecraft.dead_tube_coral_wall_fan": "牆上的死亡扇狀管珊瑚",
  "block.minecraft.decorated_pot": "裝飾陶罐",
  "block.minecraft.deepslate": "深板巖",
  "block.minecraft.deepslate_brick_slab": "深板巖磚半磚",
  "block.minecraft.deepslate_brick_stairs": "深板巖磚樓梯",
  "block.minecraft.deepslate_brick_wall": "深板巖磚牆",
  "block.minecraft.deepslate_bricks": "深板巖磚",
  "block.minecraft.deepslate_coal_ore": "深層煤礦",
  "block.minecraft.deepslate_copper_ore": "深層銅礦",
  "block.minecraft.deepslate_diamond_ore": "深層鑽石礦",
  "block.minecraft.deepslate_emerald_ore": "深層綠寶石礦",
  "block.minecraft.deepslate_gold_ore": "深層金礦",
  "block.minecraft.deepslate_iron_ore": "深層鐵礦",
  "block.minecraft.deepslate_lapis_ore": "深層青金石礦",
  "block.minecraft.deepslate_redstone_ore": "深層紅石礦",
  "block.minecraft.deepslate_tile_slab": "深板巖瓦半磚",
  "block.minecraft.deepslate_tile_stairs": "深板巖瓦樓梯",
  "block.minecraft.deepslate_tile_wall": "深板巖瓦牆",
  "block.minecraft.deepslate_tiles": "深板巖瓦",
  "block.minecraft.detector_rail": "感壓路軌",
  "block.minecraft.diamond_block": "鑽石磚",
  "block.minecraft.diamond_ore": "鑽石礦",
  "block.minecraft.diorite": "閃長巖",
  "block.minecraft.diorite_slab": "閃長巖半磚",
  "block.minecraft.diorite_stairs": "閃長巖樓梯",
  "block.minecraft.diorite_wall": "閃長巖牆",
  "block.minecraft.dirt": "泥土",
  "block.minecraft.dirt_path": "泥徑",
  "block.minecraft.dispenser": "發射器",
  "block.minecraft.dragon_egg": "龍蛋",
  "block.minecraft.dragon_head": "龍頭",
  "block.minecraft.dragon_wall_head": "牆上的龍頭",
  "block.minecraft.dried_ghast": "脱水幽靈",
  "block.minecraft.dried_kelp_block": "乾海帶捆",
  "block.minecraft.dripstone_block": "滴水石",
  "block.minecraft.dropper": "投擲器",
  "block.minecraft.emerald_block": "綠寶石磚",
  "block.minecraft.emerald_ore": "綠寶石礦",
  "block.minecraft.enchanting_table": "附魔台",
  "block.minecraft.end_gateway": "終界折躍門",
  "block.minecraft.end_portal": "終界傳送門",
  "block.minecraft.end_portal_frame": "終界傳送門框",
  "block.minecraft.end_rod": "終界燭",
  "block.minecraft.end_stone": "終界石",
  "block.minecraft.end_stone_brick_slab": "終界石磚半磚",
  "block.minecraft.end_stone_brick_stairs": "終界石磚樓梯",
  "block.minecraft.end_stone_brick_wall": "終界石磚牆",
  "block.minecraft.end_stone_bricks": "終界石磚",
  "block.minecraft.ender_chest": "終界箱",
  "block.minecraft.exposed_chiseled_copper": "斑駁的浮雕銅磚",
  "block.minecraft.exposed_copper": "斑駁的銅磚",
  "block.minecraft.exposed_copper_bars": "斑駁的銅欄杆",
  "block.minecraft.exposed_copper_bulb": "斑駁的銅燈",
  "block.minecraft.exposed_copper_chain": "斑駁的銅鏈",
  "block.minecraft.exposed_copper_chest": "斑駁的銅儲物箱",
  "block.minecraft.exposed_copper_door": "斑駁的銅門",
  "block.minecraft.exposed_copper_golem_statue": "斑駁的銅人雕像",
  "block.minecraft.exposed_copper_grate": "斑駁的銅網格",
  "block.minecraft.exposed_copper_lantern": "斑駁的銅燈籠",
  "block.minecraft.exposed_copper_trapdoor": "斑駁的銅地板門",
  "block.minecraft.exposed_cut_copper": "斑駁的切製銅磚",
  "block.minecraft.exposed_cut_copper_slab": "斑駁的切製銅半磚",
  "block.minecraft.exposed_cut_copper_stairs": "斑駁的切製銅樓梯",
  "block.minecraft.exposed_lightning_rod": "斑駁的避雷針",
  "block.minecraft.farmland": "耕地",
  "block.minecraft.fern": "蕨",
  "block.minecraft.fire": "火",
  "block.minecraft.fire_coral": "火珊瑚",
  "block.minecraft.fire_coral_block": "火珊瑚方塊",
  "block.minecraft.fire_coral_fan": "扇狀火珊瑚",
  "block.minecraft.fire_coral_wall_fan": "牆上的扇狀火珊瑚",
  "block.minecraft.firefly_bush": "螢火蟲灌木叢",
  "block.minecraft.fletching_table": "製箭台",
  "block.minecraft.flower_pot": "花盆",
  "block.minecraft.flowering_azalea": "盛開的杜鵑叢",
  "block.minecraft.flowering_azalea_leaves": "盛開的杜鵑樹葉",
  "block.minecraft.frogspawn": "青蛙卵",
  "block.minecraft.frosted_ice": "霜冰",
  "block.minecraft.furnace": "熔爐",
  "block.minecraft.gilded_blackstone": "鑲金黑石",
  "block.minecraft.glass": "玻璃",
  "block.minecraft.glass_pane": "玻璃片",
  "block.minecraft.glow_lichen": "發光地衣",
  "block.minecraft.glowstone": "熒光石",
  "block.minecraft.gold_block": "金磚",
  "block.minecraft.gold_ore": "金礦",
  "block.minecraft.golden_dandelion": "金蒲公英",
  "block.minecraft.granite": "花崗巖",
  "block.minecraft.granite_slab": "花崗巖半磚",
  "block.minecraft.granite_stairs": "花崗巖樓梯",
  "block.minecraft.granite_wall": "花崗巖牆",
  "block.minecraft.grass": "草",
  "block.minecraft.grass_block": "草地",
  "block.minecraft.gravel": "砂礫",
  "block.minecraft.gray_banner": "灰色橫額",
  "block.minecraft.gray_bed": "灰色牀",
  "block.minecraft.gray_candle": "灰色蠟燭",
  "block.minecraft.gray_candle_cake": "插上灰色蠟燭的蛋糕",
  "block.minecraft.gray_carpet": "灰色地氈",
  "block.minecraft.gray_concrete": "灰色混凝土",
  "block.minecraft.gray_concrete_powder": "灰色混凝土粉末",
  "block.minecraft.gray_glazed_terracotta": "灰色釉陶",
  "block.minecraft.gray_shulker_box": "灰色界伏盒",
  "block.minecraft.gray_stained_glass": "灰色染色玻璃",
  "block.minecraft.gray_stained_glass_pane": "灰色染色玻璃片",
  "block.minecraft.gray_terracotta": "灰色陶瓦",
  "block.minecraft.gray_wool": "灰色羊毛",
  "block.minecraft.green_banner": "綠色橫額",
  "block.minecraft.green_bed": "綠色牀",
  "block.minecraft.green_candle": "綠色蠟燭",
  "block.minecraft.green_candle_cake": "插上綠色蠟燭的蛋糕",
  "block.minecraft.green_carpet": "綠色地氈",
  "block.minecraft.green_concrete": "綠色混凝土",
  "block.minecraft.green_concrete_powder": "綠色混凝土粉末",
  "block.minecraft.green_glazed_terracotta": "綠色釉陶",
  "block.minecraft.green_shulker_box": "綠色界伏盒",
  "block.minecraft.green_stained_glass": "綠色染色玻璃",
  "block.minecraft.green_stained_glass_pane": "綠色染色玻璃片",
  "block.minecraft.green_terracotta": "綠色陶瓦",
  "block.minecraft.green_wool": "綠色羊毛",
  "block.minecraft.grindstone": "砂輪",
  "block.minecraft.hanging_roots": "懸根",
  "block.minecraft.hay_block": "乾草捆",
  "block.minecraft.heavy_core": "沉重核心",
  "block.minecraft.heavy_weighted_pressure_plate": "重質測重壓力板",
  "block.minecraft.honey_block": "蜜糖塊",
  "block.minecraft.honeycomb_block": "蜂巢蜜塊",
  "block.minecraft.hopper": "漏斗",
  "block.minecraft.horn_coral": "角珊瑚",
  "block.minecraft.horn_coral_block": "角珊瑚方塊",
  "block.minecraft.horn_coral_fan": "扇狀角珊瑚",
  "block.minecraft.horn_coral_wall_fan": "牆上的扇狀角珊瑚",
  "block.minecraft.ice": "冰",
  "block.minecraft.infested_chiseled_stone_bricks": "蛀蝕的浮雕石磚",
  "block.minecraft.infested_cobblestone": "蛀蝕的碎石",
  "block.minecraft.infested_cracked_stone_bricks": "蛀蝕的裂紋石磚",
  "block.minecraft.infested_deepslate": "蛀蝕的深板巖",
  "block.minecraft.infested_mossy_stone_bricks": "蛀蝕的青苔石磚",
  "block.minecraft.infested_stone": "蛀蝕的石頭",
  "block.minecraft.infested_stone_bricks": "蛀蝕的石磚",
  "block.minecraft.iron_bars": "鐵欄杆",
  "block.minecraft.iron_block": "鐵磚",
  "block.minecraft.iron_chain": "鐵鏈",
  "block.minecraft.iron_door": "鐵門",
  "block.minecraft.iron_ore": "鐵礦",
  "block.minecraft.iron_trapdoor": "鐵地板門",
  "block.minecraft.jack_o_lantern": "南瓜燈",
  "block.minecraft.jigsaw": "拼圖方塊",
  "block.minecraft.jukebox": "唱片機",
  "block.minecraft.jungle_button": "叢林木按鈕",
  "block.minecraft.jungle_door": "叢林木門",
  "block.minecraft.jungle_fence": "叢林木欄杆",
  "block.minecraft.jungle_fence_gate": "叢林木閘門",
  "block.minecraft.jungle_hanging_sign": "叢林木吊牌",
  "block.minecraft.jungle_leaves": "叢林木樹葉",
  "block.minecraft.jungle_log": "叢林木原木",
  "block.minecraft.jungle_planks": "叢林木板",
  "block.minecraft.jungle_pressure_plate": "叢林木壓力板",
  "block.minecraft.jungle_sapling": "叢林木樹苗",
  "block.minecraft.jungle_shelf": "叢林木置物架",
  "block.minecraft.jungle_sign": "叢林木指示牌",
  "block.minecraft.jungle_slab": "叢林木半磚",
  "block.minecraft.jungle_stairs": "叢林木樓梯",
  "block.minecraft.jungle_trapdoor": "叢林木地板門",
  "block.minecraft.jungle_wall_hanging_sign": "牆上的叢林木吊牌",
  "block.minecraft.jungle_wall_sign": "牆上的叢林木指示牌",
  "block.minecraft.jungle_wood": "叢林木",
  "block.minecraft.kelp": "海帶",
  "block.minecraft.kelp_plant": "海帶植株",
  "block.minecraft.ladder": "梯",
  "block.minecraft.lantern": "燈籠",
  "block.minecraft.lapis_block": "青金石磚",
  "block.minecraft.lapis_ore": "青金石礦",
  "block.minecraft.large_amethyst_bud": "大型紫水晶芽",
  "block.minecraft.large_fern": "大型蕨",
  "block.minecraft.lava": "熔巖",
  "block.minecraft.lava_cauldron": "裝熔巖的鍋",
  "block.minecraft.leaf_litter": "枯葉",
  "block.minecraft.lectern": "講台",
  "block.minecraft.lever": "拉桿",
  "block.minecraft.light": "光",
  "block.minecraft.light_blue_banner": "淺藍色橫額",
  "block.minecraft.light_blue_bed": "淺藍色牀",
  "block.minecraft.light_blue_candle": "淺藍色蠟燭",
  "block.minecraft.light_blue_candle_cake": "插上淺藍色蠟燭的蛋糕",
  "block.minecraft.light_blue_carpet": "淺藍色地氈",
  "block.minecraft.light_blue_concrete": "淺藍色混凝土",
  "block.minecraft.light_blue_concrete_powder": "淺藍色混凝土粉末",
  "block.minecraft.light_blue_glazed_terracotta": "淺藍色釉陶",
  "block.minecraft.light_blue_shulker_box": "淺藍色界伏盒",
  "block.minecraft.light_blue_stained_glass": "淺藍色染色玻璃",
  "block.minecraft.light_blue_stained_glass_pane": "淺藍色染色玻璃片",
  "block.minecraft.light_blue_terracotta": "淺藍色陶瓦",
  "block.minecraft.light_blue_wool": "淺藍色羊毛",
  "block.minecraft.light_gray_banner": "淺灰色橫額",
  "block.minecraft.light_gray_bed": "淺灰色牀",
  "block.minecraft.light_gray_candle": "淺灰色蠟燭",
  "block.minecraft.light_gray_candle_cake": "插上淺灰色蠟燭的蛋糕",
  "block.minecraft.light_gray_carpet": "淺灰色地氈",
  "block.minecraft.light_gray_concrete": "淺灰色混凝土",
  "block.minecraft.light_gray_concrete_powder": "淺灰色混凝土粉末",
  "block.minecraft.light_gray_glazed_terracotta": "淺灰色釉陶",
  "block.minecraft.light_gray_shulker_box": "淺灰色界伏盒",
  "block.minecraft.light_gray_stained_glass": "淺灰色染色玻璃",
  "block.minecraft.light_gray_stained_glass_pane": "淺灰色染色玻璃片",
  "block.minecraft.light_gray_terracotta": "淺灰色陶瓦",
  "block.minecraft.light_gray_wool": "淺灰色羊毛",
  "block.minecraft.light_weighted_pressure_plate": "輕質測重壓力板",
  "block.minecraft.lightning_rod": "避雷針",
  "block.minecraft.lilac": "紫丁香",
  "block.minecraft.lily_of_the_valley": "鈴蘭",
  "block.minecraft.lily_pad": "荷葉",
  "block.minecraft.lime_banner": "淺綠色橫額",
  "block.minecraft.lime_bed": "淺綠色牀",
  "block.minecraft.lime_candle": "淺綠色蠟燭",
  "block.minecraft.lime_candle_cake": "插上淺綠色蠟燭的蛋糕",
  "block.minecraft.lime_carpet": "淺綠色地氈",
  "block.minecraft.lime_concrete": "淺綠色混凝土",
  "block.minecraft.lime_concrete_powder": "淺綠色混凝土粉末",
  "block.minecraft.lime_glazed_terracotta": "淺綠色釉陶",
  "block.minecraft.lime_shulker_box": "淺綠色界伏盒",
  "block.minecraft.lime_stained_glass": "淺綠色染色玻璃",
  "block.minecraft.lime_stained_glass_pane": "淺綠色染色玻璃片",
  "block.minecraft.lime_terracotta": "淺綠色陶瓦",
  "block.minecraft.lime_wool": "淺綠色羊毛",
  "block.minecraft.lodestone": "磁石",
  "block.minecraft.loom": "織布機",
  "block.minecraft.magenta_banner": "紫紅色橫額",
  "block.minecraft.magenta_bed": "紫紅色牀",
  "block.minecraft.magenta_candle": "紫紅色蠟燭",
  "block.minecraft.magenta_candle_cake": "插上紫紅色蠟燭的蛋糕",
  "block.minecraft.magenta_carpet": "紫紅色地氈",
  "block.minecraft.magenta_concrete": "紫紅色混凝土",
  "block.minecraft.magenta_concrete_powder": "紫紅色混凝土粉末",
  "block.minecraft.magenta_glazed_terracotta": "紫紅色釉陶",
  "block.minecraft.magenta_shulker_box": "紫紅色界伏盒",
  "block.minecraft.magenta_stained_glass": "紫紅色染色玻璃",
  "block.minecraft.magenta_stained_glass_pane": "紫紅色染色玻璃片",
  "block.minecraft.magenta_terracotta": "紫紅色陶瓦",
  "block.minecraft.magenta_wool": "紫紅色羊毛",
  "block.minecraft.magma_block": "巖漿塊",
  "block.minecraft.mangrove_button": "紅樹木按鈕",
  "block.minecraft.mangrove_door": "紅樹木門",
  "block.minecraft.mangrove_fence": "紅樹木欄杆",
  "block.minecraft.mangrove_fence_gate": "紅樹木閘門",
  "block.minecraft.mangrove_hanging_sign": "紅樹木吊牌",
  "block.minecraft.mangrove_leaves": "紅樹樹葉",
  "block.minecraft.mangrove_log": "紅樹原木",
  "block.minecraft.mangrove_planks": "紅樹木板",
  "block.minecraft.mangrove_pressure_plate": "紅樹木壓力板",
  "block.minecraft.mangrove_propagule": "紅樹胎生苗",
  "block.minecraft.mangrove_roots": "紅樹根",
  "block.minecraft.mangrove_shelf": "紅樹木置物架",
  "block.minecraft.mangrove_sign": "紅樹木指示牌",
  "block.minecraft.mangrove_slab": "紅樹木半磚",
  "block.minecraft.mangrove_stairs": "紅樹木樓梯",
  "block.minecraft.mangrove_trapdoor": "紅樹木地板門",
  "block.minecraft.mangrove_wall_hanging_sign": "牆上的紅樹木吊牌",
  "block.minecraft.mangrove_wall_sign": "牆上的紅樹木指示牌",
  "block.minecraft.mangrove_wood": "紅樹木",
  "block.minecraft.medium_amethyst_bud": "中型紫水晶芽",
  "block.minecraft.melon": "西瓜",
  "block.minecraft.melon_stem": "西瓜莖",
  "block.minecraft.moss_block": "青苔方塊",
  "block.minecraft.moss_carpet": "青苔",
  "block.minecraft.mossy_cobblestone": "青苔碎石",
  "block.minecraft.mossy_cobblestone_slab": "青苔碎石半磚",
  "block.minecraft.mossy_cobblestone_stairs": "青苔碎石樓梯",
  "block.minecraft.mossy_cobblestone_wall": "青苔碎石牆",
  "block.minecraft.mossy_stone_brick_slab": "青苔石磚半磚",
  "block.minecraft.mossy_stone_brick_stairs": "青苔石磚樓梯",
  "block.minecraft.mossy_stone_brick_wall": "青苔石磚牆",
  "block.minecraft.mossy_stone_bricks": "青苔石磚",
  "block.minecraft.moving_piston": "移動的活塞",
  "block.minecraft.mud": "泥",
  "block.minecraft.mud_brick_slab": "泥磚半磚",
  "block.minecraft.mud_brick_stairs": "泥磚樓梯",
  "block.minecraft.mud_brick_wall": "泥磚牆",
  "block.minecraft.mud_bricks": "泥磚",
  "block.minecraft.muddy_mangrove_roots": "泥濘的紅樹根",
  "block.minecraft.mushroom_stem": "蘑菇柄",
  "block.minecraft.mycelium": "菌絲土",
  "block.minecraft.nether_brick_fence": "地獄磚欄杆",
  "block.minecraft.nether_brick_slab": "地獄磚半磚",
  "block.minecraft.nether_brick_stairs": "地獄磚樓梯",
  "block.minecraft.nether_brick_wall": "地獄磚牆",
  "block.minecraft.nether_bricks": "地獄磚",
  "block.minecraft.nether_gold_ore": "地獄金礦",
  "block.minecraft.nether_portal": "地獄傳送門",
  "block.minecraft.nether_quartz_ore": "地獄石英礦",
  "block.minecraft.nether_sprouts": "地獄芽",
  "block.minecraft.nether_wart": "地獄孢子",
  "block.minecraft.nether_wart_block": "地獄孢子塊",
  "block.minecraft.netherite_block": "地獄合金磚",
  "block.minecraft.netherrack": "地獄石",
  "block.minecraft.note_block": "音符盒",
  "block.minecraft.oak_button": "橡木按鈕",
  "block.minecraft.oak_door": "橡木門",
  "block.minecraft.oak_fence": "橡木欄杆",
  "block.minecraft.oak_fence_gate": "橡木閘門",
  "block.minecraft.oak_hanging_sign": "橡木吊牌",
  "block.minecraft.oak_leaves": "橡木樹葉",
  "block.minecraft.oak_log": "橡木原木",
  "block.minecraft.oak_planks": "橡木板",
  "block.minecraft.oak_pressure_plate": "橡木壓力板",
  "block.minecraft.oak_sapling": "橡木樹苗",
  "block.minecraft.oak_shelf": "橡木置物架",
  "block.minecraft.oak_sign": "橡木指示牌",
  "block.minecraft.oak_slab": "橡木半磚",
  "block.minecraft.oak_stairs": "橡木樓梯",
  "block.minecraft.oak_trapdoor": "橡木地板門",
  "block.minecraft.oak_wall_hanging_sign": "牆上的橡木吊牌",
  "block.minecraft.oak_wall_sign": "牆上的橡木指示牌",
  "block.minecraft.oak_wood": "橡木",
  "block.minecraft.observer": "偵測器",
  "block.minecraft.obsidian": "黑曜石",
  "block.minecraft.ochre_froglight": "赭黃蛙明燈",
  "block.minecraft.ominous_banner": "不祥橫額",
  "block.minecraft.open_eyeblossom": "張開的眼眸花",
  "block.minecraft.orange_banner": "橙色橫額",
  "block.minecraft.orange_bed": "橙色牀",
  "block.minecraft.orange_candle": "橙色蠟燭",
  "block.minecraft.orange_candle_cake": "插上橙色蠟燭的蛋糕",
  "block.minecraft.orange_carpet": "橙色地氈",
  "block.minecraft.orange_concrete": "橙色混凝土",
  "block.minecraft.orange_concrete_powder": "橙色混凝土粉末",
  "block.minecraft.orange_glazed_terracotta": "橙色釉陶",
  "block.minecraft.orange_shulker_box": "橙色界伏盒",
  "block.minecraft.orange_stained_glass": "橙色染色玻璃",
  "block.minecraft.orange_stained_glass_pane": "橙色染色玻璃片",
  "block.minecraft.orange_terracotta": "橙色陶瓦",
  "block.minecraft.orange_tulip": "橙色鬱金香",
  "block.minecraft.orange_wool": "橙色羊毛",
  "block.minecraft.oxeye_daisy": "雛菊",
  "block.minecraft.oxidized_chiseled_copper": "氧化的浮雕銅磚",
  "block.minecraft.oxidized_copper": "氧化的銅磚",
  "block.minecraft.oxidized_copper_bars": "氧化的銅欄杆",
  "block.minecraft.oxidized_copper_bulb": "氧化的銅燈",
  "block.minecraft.oxidized_copper_chain": "氧化的銅鏈",
  "block.minecraft.oxidized_copper_chest": "氧化的銅儲物箱",
  "block.minecraft.oxidized_copper_door": "氧化的銅門",
  "block.minecraft.oxidized_copper_golem_statue": "氧化的銅人雕像",
  "block.minecraft.oxidized_copper_grate": "氧化的銅網格",
  "block.minecraft.oxidized_copper_lantern": "氧化的銅燈籠",
  "block.minecraft.oxidized_copper_trapdoor": "氧化的銅地板門",
  "block.minecraft.oxidized_cut_copper": "氧化的切製銅磚",
  "block.minecraft.oxidized_cut_copper_slab": "氧化的切製銅半磚",
  "block.minecraft.oxidized_cut_copper_stairs": "氧化的切製銅樓梯",
  "block.minecraft.oxidized_lightning_rod": "氧化的避雷針",
  "block.minecraft.packed_ice": "冰磚",
  "block.minecraft.packed_mud": "泥坯",
  "block.minecraft.pale_hanging_moss": "蒼白垂鬚",
  "block.minecraft.pale_moss_block": "蒼白青苔方塊",
  "block.minecraft.pale_moss_carpet": "蒼白青苔",
  "block.minecraft.pale_oak_button": "蒼白橡木按鈕",
  "block.minecraft.pale_oak_door": "蒼白橡木門",
  "block.minecraft.pale_oak_fence": "蒼白橡木欄杆",
  "block.minecraft.pale_oak_fence_gate": "蒼白橡木閘門",
  "block.minecraft.pale_oak_hanging_sign": "蒼白橡木吊牌",
  "block.minecraft.pale_oak_leaves": "蒼白橡木樹葉",
  "block.minecraft.pale_oak_log": "蒼白橡木原木",
  "block.minecraft.pale_oak_planks": "蒼白橡木板",
  "block.minecraft.pale_oak_pressure_plate": "蒼白橡木壓力板",
  "block.minecraft.pale_oak_sapling": "蒼白橡木樹苗",
  "block.minecraft.pale_oak_shelf": "蒼白橡木置物架",
  "block.minecraft.pale_oak_sign": "蒼白橡木指示牌",
  "block.minecraft.pale_oak_slab": "蒼白橡木半磚",
  "block.minecraft.pale_oak_stairs": "蒼白橡木樓梯",
  "block.minecraft.pale_oak_trapdoor": "蒼白橡木地板門",
  "block.minecraft.pale_oak_wall_hanging_sign": "牆上的蒼白橡木吊牌",
  "block.minecraft.pale_oak_wall_sign": "牆上的蒼白橡木指示牌",
  "block.minecraft.pale_oak_wood": "蒼白橡木",
  "block.minecraft.pearlescent_froglight": "珠光蛙明燈",
  "block.minecraft.peony": "牡丹花",
  "block.minecraft.petrified_oak_slab": "石化橡木半磚",
  "block.minecraft.piglin_head": "豬人頭顱",
  "block.minecraft.piglin_wall_head": "牆上的豬人頭顱",
  "block.minecraft.pink_banner": "粉紅色橫額",
  "block.minecraft.pink_bed": "粉紅色牀",
  "block.minecraft.pink_candle": "粉紅色蠟燭",
  "block.minecraft.pink_candle_cake": "插上粉紅色蠟燭的蛋糕",
  "block.minecraft.pink_carpet": "粉紅色地氈",
  "block.minecraft.pink_concrete": "粉紅色混凝土",
  "block.minecraft.pink_concrete_powder": "粉紅色混凝土粉末",
  "block.minecraft.pink_glazed_terracotta": "粉紅色釉陶",
  "block.minecraft.pink_petals": "粉紅色花簇",
  "block.minecraft.pink_shulker_box": "粉紅色界伏盒",
  "block.minecraft.pink_stained_glass": "粉紅色染色玻璃",
  "block.minecraft.pink_stained_glass_pane": "粉紅色染色玻璃片",
  "block.minecraft.pink_terracotta": "粉紅色陶瓦",
  "block.minecraft.pink_tulip": "粉紅色鬱金香",
  "block.minecraft.pink_wool": "粉紅色羊毛",
  "block.minecraft.piston": "活塞",
  "block.minecraft.piston_head": "活塞頭",
  "block.minecraft.pitcher_crop": "樽草植株",
  "block.minecraft.pitcher_plant": "樽草",
  "block.minecraft.player_head": "玩家頭顱",
  "block.minecraft.player_head.named": "%s 的頭顱",
  "block.minecraft.player_wall_head": "牆上的玩家頭顱",
  "block.minecraft.podzol": "灰壤",
  "block.minecraft.pointed_dripstone": "滴水石柱",
  "block.minecraft.polished_andesite": "拋光安山巖",
  "block.minecraft.polished_andesite_slab": "拋光安山巖半磚",
  "block.minecraft.polished_andesite_stairs": "拋光安山巖樓梯",
  "block.minecraft.polished_basalt": "拋光玄武巖",
  "block.minecraft.polished_blackstone": "拋光黑石",
  "block.minecraft.polished_blackstone_brick_slab": "拋光黑石磚半磚",
  "block.minecraft.polished_blackstone_brick_stairs": "拋光黑石磚樓梯",
  "block.minecraft.polished_blackstone_brick_wall": "拋光黑石磚牆",
  "block.minecraft.polished_blackstone_bricks": "拋光黑石磚",
  "block.minecraft.polished_blackstone_button": "拋光黑石按鈕",
  "block.minecraft.polished_blackstone_pressure_plate": "拋光黑石壓力板",
  "block.minecraft.polished_blackstone_slab": "拋光黑石半磚",
  "block.minecraft.polished_blackstone_stairs": "拋光黑石樓梯",
  "block.minecraft.polished_blackstone_wall": "拋光黑石牆",
  "block.minecraft.polished_deepslate": "拋光深板巖",
  "block.minecraft.polished_deepslate_slab": "拋光深板巖半磚",
  "block.minecraft.polished_deepslate_stairs": "拋光深板巖樓梯",
  "block.minecraft.polished_deepslate_wall": "拋光深板巖牆",
  "block.minecraft.polished_diorite": "拋光閃長巖",
  "block.minecraft.polished_diorite_slab": "拋光閃長巖半磚",
  "block.minecraft.polished_diorite_stairs": "拋光閃長巖樓梯",
  "block.minecraft.polished_granite": "拋光花崗巖",
  "block.minecraft.polished_granite_slab": "拋光花崗巖半磚",
  "block.minecraft.polished_granite_stairs": "拋光花崗巖樓梯",
  "block.minecraft.polished_tuff": "拋光凝灰巖",
  "block.minecraft.polished_tuff_slab": "拋光凝灰巖半磚",
  "block.minecraft.polished_tuff_stairs": "拋光凝灰巖樓梯",
  "block.minecraft.polished_tuff_wall": "拋光凝灰巖牆",
  "block.minecraft.poppy": "罌粟",
  "block.minecraft.potatoes": "薯仔",
  "block.minecraft.potted_acacia_sapling": "相思木樹苗盆栽",
  "block.minecraft.potted_allium": "絨球葱盆栽",
  "block.minecraft.potted_azalea_bush": "杜鵑叢盆栽",
  "block.minecraft.potted_azure_bluet": "藍花美耳草盆栽",
  "block.minecraft.potted_bamboo": "竹盆栽",
  "block.minecraft.potted_birch_sapling": "樺木樹苗盆栽",
  "block.minecraft.potted_blue_orchid": "蘭花盆栽",
  "block.minecraft.potted_brown_mushroom": "啡色蘑菇盆栽",
  "block.minecraft.potted_cactus": "仙人掌盆栽",
  "block.minecraft.potted_cherry_sapling": "櫻花樹苗盆栽",
  "block.minecraft.potted_closed_eyeblossom": "閉合的眼眸花盆栽",
  "block.minecraft.potted_cornflower": "矢車菊盆栽",
  "block.minecraft.potted_crimson_fungus": "猩紅菌菇盆栽",
  "block.minecraft.potted_crimson_roots": "猩紅菌根盆栽",
  "block.minecraft.potted_dandelion": "蒲公英盆栽",
  "block.minecraft.potted_dark_oak_sapling": "黑橡木樹苗盆栽",
  "block.minecraft.potted_dead_bush": "死灌木盆栽",
  "block.minecraft.potted_fern": "蕨盆栽",
  "block.minecraft.potted_flowering_azalea_bush": "盛開的杜鵑叢盆栽",
  "block.minecraft.potted_golden_dandelion": "金蒲公英盆栽",
  "block.minecraft.potted_jungle_sapling": "叢林木樹苗盆栽",
  "block.minecraft.potted_lily_of_the_valley": "鈴蘭盆栽",
  "block.minecraft.potted_mangrove_propagule": "紅樹胎生苗盆栽",
  "block.minecraft.potted_oak_sapling": "橡木樹苗盆栽",
  "block.minecraft.potted_open_eyeblossom": "張開的眼眸花盆栽",
  "block.minecraft.potted_orange_tulip": "橙色鬱金香盆栽",
  "block.minecraft.potted_oxeye_daisy": "雛菊盆栽",
  "block.minecraft.potted_pale_oak_sapling": "蒼白橡木樹苗盆栽",
  "block.minecraft.potted_pink_tulip": "粉紅色鬱金香盆栽",
  "block.minecraft.potted_poppy": "罌粟盆栽",
  "block.minecraft.potted_red_mushroom": "紅色蘑菇盆栽",
  "block.minecraft.potted_red_tulip": "紅色鬱金香盆栽",
  "block.minecraft.potted_spruce_sapling": "杉木樹苗盆栽",
  "block.minecraft.potted_torchflower": "火炬花盆栽",
  "block.minecraft.potted_warped_fungus": "迷離菌菇盆栽",
  "block.minecraft.potted_warped_roots": "迷離菌根盆栽",
  "block.minecraft.potted_white_tulip": "白色鬱金香盆栽",
  "block.minecraft.potted_wither_rose": "凋零玫瑰盆栽",
  "block.minecraft.powder_snow": "幼雪",
  "block.minecraft.powder_snow_cauldron": "裝幼雪的鍋",
  "block.minecraft.powered_rail": "動力路軌",
  "block.minecraft.prismarine": "海磷石",
  "block.minecraft.prismarine_brick_slab": "海磷石磚半磚",
  "block.minecraft.prismarine_brick_stairs": "海磷石磚樓梯",
  "block.minecraft.prismarine_bricks": "海磷石磚",
  "block.minecraft.prismarine_slab": "海磷石半磚",
  "block.minecraft.prismarine_stairs": "海磷石樓梯",
  "block.minecraft.prismarine_wall": "海磷石牆",
  "block.minecraft.pumpkin": "南瓜",
  "block.minecraft.pumpkin_stem": "南瓜莖",
  "block.minecraft.purple_banner": "紫色橫額",
  "block.minecraft.purple_bed": "紫色牀",
  "block.minecraft.purple_candle": "紫色蠟燭",
  "block.minecraft.purple_candle_cake": "插上紫色蠟燭的蛋糕",
  "block.minecraft.purple_carpet": "紫色地氈",
  "block.minecraft.purple_concrete": "紫色混凝土",
  "block.minecraft.purple_concrete_powder": "紫色混凝土粉末",
  "block.minecraft.purple_glazed_terracotta": "紫色釉陶",
  "block.minecraft.purple_shulker_box": "紫色界伏盒",
  "block.minecraft.purple_stained_glass": "紫色染色玻璃",
  "block.minecraft.purple_stained_glass_pane": "紫色染色玻璃片",
  "block.minecraft.purple_terracotta": "紫色陶瓦",
  "block.minecraft.purple_wool": "紫色羊毛",
  "block.minecraft.purpur_block": "紫珀磚",
  "block.minecraft.purpur_pillar": "紫珀柱",
  "block.minecraft.purpur_slab": "紫珀半磚",
  "block.minecraft.purpur_stairs": "紫珀樓梯",
  "block.minecraft.quartz_block": "石英磚",
  "block.minecraft.quartz_bricks": "磚紋石英磚",
  "block.minecraft.quartz_pillar": "石英柱",
  "block.minecraft.quartz_slab": "石英半磚",
  "block.minecraft.quartz_stairs": "石英樓梯",
  "block.minecraft.rail": "路軌",
  "block.minecraft.raw_copper_block": "粗銅磚",
  "block.minecraft.raw_gold_block": "粗金磚",
  "block.minecraft.raw_iron_block": "粗鐵磚",
  "block.minecraft.red_banner": "紅色橫額",
  "block.minecraft.red_bed": "紅色牀",
  "block.minecraft.red_candle": "紅色蠟燭",
  "block.minecraft.red_candle_cake": "插上紅色蠟燭的蛋糕",
  "block.minecraft.red_carpet": "紅色地氈",
  "block.minecraft.red_concrete": "紅色混凝土",
  "block.minecraft.red_concrete_powder": "紅色混凝土粉末",
  "block.minecraft.red_glazed_terracotta": "紅色釉陶",
  "block.minecraft.red_mushroom": "紅色蘑菇",
  "block.minecraft.red_mushroom_block": "紅色蘑菇方塊",
  "block.minecraft.red_nether_brick_slab": "紅色地獄磚半磚",
  "block.minecraft.red_nether_brick_stairs": "紅色地獄磚樓梯",
  "block.minecraft.red_nether_brick_wall": "紅色地獄磚牆",
  "block.minecraft.red_nether_bricks": "紅色地獄磚",
  "block.minecraft.red_sand": "紅沙",
  "block.minecraft.red_sandstone": "紅砂巖",
  "block.minecraft.red_sandstone_slab": "紅砂巖半磚",
  "block.minecraft.red_sandstone_stairs": "紅砂巖樓梯",
  "block.minecraft.red_sandstone_wall": "紅砂巖牆",
  "block.minecraft.red_shulker_box": "紅色界伏盒",
  "block.minecraft.red_stained_glass": "紅色染色玻璃",
  "block.minecraft.red_stained_glass_pane": "紅色染色玻璃片",
  "block.minecraft.red_terracotta": "紅色陶瓦",
  "block.minecraft.red_tulip": "紅色鬱金香",
  "block.minecraft.red_wool": "紅色羊毛",
  "block.minecraft.redstone_block": "紅石磚",
  "block.minecraft.redstone_lamp": "紅石燈",
  "block.minecraft.redstone_ore": "紅石礦",
  "block.minecraft.redstone_torch": "紅石火炬",
  "block.minecraft.redstone_wall_torch": "牆上的紅石火炬",
  "block.minecraft.redstone_wire": "紅石線",
  "block.minecraft.reinforced_deepslate": "強化深板巖",
  "block.minecraft.repeater": "紅石中繼器",
  "block.minecraft.repeating_command_block": "重複型命令方塊",
  "block.minecraft.resin_block": "樹脂塊",
  "block.minecraft.resin_brick_slab": "樹脂磚半磚",
  "block.minecraft.resin_brick_stairs": "樹脂磚樓梯",
  "block.minecraft.resin_brick_wall": "樹脂磚牆",
  "block.minecraft.resin_bricks": "樹脂磚",
  "block.minecraft.resin_clump": "樹脂團",
  "block.minecraft.respawn_anchor": "重生錨",
  "block.minecraft.rooted_dirt": "扎根泥",
  "block.minecraft.rose_bush": "玫瑰叢",
  "block.minecraft.sand": "沙",
  "block.minecraft.sandstone": "砂巖",
  "block.minecraft.sandstone_slab": "砂巖半磚",
  "block.minecraft.sandstone_stairs": "砂巖樓梯",
  "block.minecraft.sandstone_wall": "砂巖牆",
  "block.minecraft.scaffolding": "棚架",
  "block.minecraft.sculk": "沉靈方塊",
  "block.minecraft.sculk_catalyst": "沉靈催發器",
  "block.minecraft.sculk_sensor": "沉靈傳感器",
  "block.minecraft.sculk_shrieker": "沉靈尖嘯器",
  "block.minecraft.sculk_vein": "沉靈脈絡",
  "block.minecraft.sea_lantern": "海燈籠",
  "block.minecraft.sea_pickle": "海鞘",
  "block.minecraft.seagrass": "海草",
  "block.minecraft.set_spawn": "已設定重生點",
  "block.minecraft.short_dry_grass": "矮枯草",
  "block.minecraft.short_grass": "矮草叢",
  "block.minecraft.shroomlight": "菌光體",
  "block.minecraft.shulker_box": "界伏盒",
  "block.minecraft.skeleton_skull": "骷髏骨頭顱",
  "block.minecraft.skeleton_wall_skull": "牆上的骷髏骨頭顱",
  "block.minecraft.slime_block": "史萊姆方塊",
  "block.minecraft.small_amethyst_bud": "小型紫水晶芽",
  "block.minecraft.small_dripleaf": "細懸葉草",
  "block.minecraft.smithing_table": "鍛造台",
  "block.minecraft.smoker": "煙燻爐",
  "block.minecraft.smooth_basalt": "平滑玄武巖",
  "block.minecraft.smooth_quartz": "平滑石英磚",
  "block.minecraft.smooth_quartz_slab": "平滑石英半磚",
  "block.minecraft.smooth_quartz_stairs": "平滑石英樓梯",
  "block.minecraft.smooth_red_sandstone": "平滑紅砂巖",
  "block.minecraft.smooth_red_sandstone_slab": "平滑紅砂巖半磚",
  "block.minecraft.smooth_red_sandstone_stairs": "平滑紅砂巖樓梯",
  "block.minecraft.smooth_sandstone": "平滑砂巖",
  "block.minecraft.smooth_sandstone_slab": "平滑砂巖半磚",
  "block.minecraft.smooth_sandstone_stairs": "平滑砂巖樓梯",
  "block.minecraft.smooth_stone": "平滑石頭",
  "block.minecraft.smooth_stone_slab": "平滑石頭半磚",
  "block.minecraft.sniffer_egg": "嗅探獸蛋",
  "block.minecraft.snow": "雪",
  "block.minecraft.snow_block": "雪塊",
  "block.minecraft.soul_campfire": "靈魂營火",
  "block.minecraft.soul_fire": "靈魂火",
  "block.minecraft.soul_lantern": "靈魂燈籠",
  "block.minecraft.soul_sand": "靈魂砂",
  "block.minecraft.soul_soil": "靈魂土",
  "block.minecraft.soul_torch": "靈魂火炬",
  "block.minecraft.soul_wall_torch": "牆上的靈魂火炬",
  "block.minecraft.spawn.not_valid": "你的牀或附有能量的重生錨不存在或已被阻擋",
  "block.minecraft.spawner": "生怪籠",
  "block.minecraft.spawner.desc1": "用生成蛋互動時：",
  "block.minecraft.spawner.desc2": "設定生物類型",
  "block.minecraft.sponge": "海綿",
  "block.minecraft.spore_blossom": "孢子花",
  "block.minecraft.spruce_button": "杉木按鈕",
  "block.minecraft.spruce_door": "杉木門",
  "block.minecraft.spruce_fence": "杉木欄杆",
  "block.minecraft.spruce_fence_gate": "杉木閘門",
  "block.minecraft.spruce_hanging_sign": "杉木吊牌",
  "block.minecraft.spruce_leaves": "杉木樹葉",
  "block.minecraft.spruce_log": "杉木原木",
  "block.minecraft.spruce_planks": "杉木板",
  "block.minecraft.spruce_pressure_plate": "杉木壓力板",
  "block.minecraft.spruce_sapling": "杉木樹苗",
  "block.minecraft.spruce_shelf": "杉木置物架",
  "block.minecraft.spruce_sign": "杉木指示牌",
  "block.minecraft.spruce_slab": "杉木半磚",
  "block.minecraft.spruce_stairs": "杉木樓梯",
  "block.minecraft.spruce_trapdoor": "杉木地板門",
  "block.minecraft.spruce_wall_hanging_sign": "牆上的杉木吊牌",
  "block.minecraft.spruce_wall_sign": "牆上的杉木指示牌",
  "block.minecraft.spruce_wood": "杉木",
  "block.minecraft.sticky_piston": "黏性活塞",
  "block.minecraft.stone": "石頭",
  "block.minecraft.stone_brick_slab": "石磚半磚",
  "block.minecraft.stone_brick_stairs": "石磚樓梯",
  "block.minecraft.stone_brick_wall": "石磚牆",
  "block.minecraft.stone_bricks": "石磚",
  "block.minecraft.stone_button": "石按鈕",
  "block.minecraft.stone_pressure_plate": "石壓力板",
  "block.minecraft.stone_slab": "石頭半磚",
  "block.minecraft.stone_stairs": "石頭樓梯",
  "block.minecraft.stonecutter": "切石機",
  "block.minecraft.stripped_acacia_log": "剝皮相思木原木",
  "block.minecraft.stripped_acacia_wood": "剝皮相思木",
  "block.minecraft.stripped_bamboo_block": "剝皮竹塊",
  "block.minecraft.stripped_birch_log": "剝皮樺木原木",
  "block.minecraft.stripped_birch_wood": "剝皮樺木",
  "block.minecraft.stripped_cherry_log": "剝皮櫻花原木",
  "block.minecraft.stripped_cherry_wood": "剝皮櫻花木",
  "block.minecraft.stripped_crimson_hyphae": "剝皮猩紅菌絲體",
  "block.minecraft.stripped_crimson_stem": "剝皮猩紅菌柄",
  "block.minecraft.stripped_dark_oak_log": "剝皮黑橡木原木",
  "block.minecraft.stripped_dark_oak_wood": "剝皮黑橡木",
  "block.minecraft.stripped_jungle_log": "剝皮叢林木原木",
  "block.minecraft.stripped_jungle_wood": "剝皮叢林木",
  "block.minecraft.stripped_mangrove_log": "剝皮紅樹原木",
  "block.minecraft.stripped_mangrove_wood": "剝皮紅樹木",
  "block.minecraft.stripped_oak_log": "剝皮橡木原木",
  "block.minecraft.stripped_oak_wood": "剝皮橡木",
  "block.minecraft.stripped_pale_oak_log": "剝皮蒼白橡木原木",
  "block.minecraft.stripped_pale_oak_wood": "剝皮蒼白橡木",
  "block.minecraft.stripped_spruce_log": "剝皮杉木原木",
  "block.minecraft.stripped_spruce_wood": "剝皮杉木",
  "block.minecraft.stripped_warped_hyphae": "剝皮迷離菌絲體",
  "block.minecraft.stripped_warped_stem": "剝皮迷離菌柄",
  "block.minecraft.structure_block": "結構方塊",
  "block.minecraft.structure_void": "結構空位",
  "block.minecraft.sugar_cane": "蔗",
  "block.minecraft.sunflower": "向日葵",
  "block.minecraft.suspicious_gravel": "可疑的砂礫",
  "block.minecraft.suspicious_sand": "可疑的沙",
  "block.minecraft.sweet_berry_bush": "甜莓灌木叢",
  "block.minecraft.tall_dry_grass": "高枯草",
  "block.minecraft.tall_grass": "長草叢",
  "block.minecraft.tall_seagrass": "長海草",
  "block.minecraft.target": "標靶",
  "block.minecraft.terracotta": "陶瓦",
  "block.minecraft.test_block": "測試方塊",
  "block.minecraft.test_instance_block": "測試實例方塊",
  "block.minecraft.tinted_glass": "遮光玻璃",
  "block.minecraft.tnt": "TNT",
  "block.minecraft.tnt.disabled": "TNT 爆炸已停用",
  "block.minecraft.torch": "火炬",
  "block.minecraft.torchflower": "火炬花",
  "block.minecraft.torchflower_crop": "火炬花植株",
  "block.minecraft.trapped_chest": "陷阱箱",
  "block.minecraft.trial_spawner": "試煉生怪籠",
  "block.minecraft.tripwire": "撠線",
  "block.minecraft.tripwire_hook": "撠線鈎",
  "block.minecraft.tube_coral": "管珊瑚",
  "block.minecraft.tube_coral_block": "管珊瑚方塊",
  "block.minecraft.tube_coral_fan": "扇狀管珊瑚",
  "block.minecraft.tube_coral_wall_fan": "牆上的扇狀管珊瑚",
  "block.minecraft.tuff": "凝灰巖",
  "block.minecraft.tuff_brick_slab": "凝灰巖磚半磚",
  "block.minecraft.tuff_brick_stairs": "凝灰巖磚樓梯",
  "block.minecraft.tuff_brick_wall": "凝灰巖磚牆",
  "block.minecraft.tuff_bricks": "凝灰巖磚",
  "block.minecraft.tuff_slab": "凝灰巖半磚",
  "block.minecraft.tuff_stairs": "凝灰巖樓梯",
  "block.minecraft.tuff_wall": "凝灰巖牆",
  "block.minecraft.turtle_egg": "海龜蛋",
  "block.minecraft.twisting_vines": "扭曲藤",
  "block.minecraft.twisting_vines_plant": "扭曲藤植株",
  "block.minecraft.vault": "寶庫",
  "block.minecraft.verdant_froglight": "青翠蛙明燈",
  "block.minecraft.vine": "藤蔓",
  "block.minecraft.void_air": "虛空空氣",
  "block.minecraft.wall_torch": "牆上的火炬",
  "block.minecraft.warped_button": "迷離菌木按鈕",
  "block.minecraft.warped_door": "迷離菌木門",
  "block.minecraft.warped_fence": "迷離菌木欄杆",
  "block.minecraft.warped_fence_gate": "迷離菌木閘門",
  "block.minecraft.warped_fungus": "迷離菌菇",
  "block.minecraft.warped_hanging_sign": "迷離菌木吊牌",
  "block.minecraft.warped_hyphae": "迷離菌絲體",
  "block.minecraft.warped_nylium": "迷離菌絲石",
  "block.minecraft.warped_planks": "迷離菌木板",
  "block.minecraft.warped_pressure_plate": "迷離菌木壓力板",
  "block.minecraft.warped_roots": "迷離菌根",
  "block.minecraft.warped_shelf": "迷離菌木置物架",
  "block.minecraft.warped_sign": "迷離菌木指示牌",
  "block.minecraft.warped_slab": "迷離菌木半磚",
  "block.minecraft.warped_stairs": "迷離菌木樓梯",
  "block.minecraft.warped_stem": "迷離菌柄",
  "block.minecraft.warped_trapdoor": "迷離菌木地板門",
  "block.minecraft.warped_wall_hanging_sign": "牆上的迷離菌木吊牌",
  "block.minecraft.warped_wall_sign": "牆上的迷離菌木指示牌",
  "block.minecraft.warped_wart_block": "迷離孢子塊",
  "block.minecraft.water": "水",
  "block.minecraft.water_cauldron": "裝水的鍋",
  "block.minecraft.waxed_chiseled_copper": "打蠟的浮雕銅磚",
  "block.minecraft.waxed_copper_bars": "打蠟的銅欄杆",
  "block.minecraft.waxed_copper_block": "打蠟的銅磚",
  "block.minecraft.waxed_copper_bulb": "打蠟的銅燈",
  "block.minecraft.waxed_copper_chain": "打蠟的銅鏈",
  "block.minecraft.waxed_copper_chest": "打蠟的銅儲物箱",
  "block.minecraft.waxed_copper_door": "打蠟的銅門",
  "block.minecraft.waxed_copper_golem_statue": "打蠟的銅人雕像",
  "block.minecraft.waxed_copper_grate": "打蠟的銅網格",
  "block.minecraft.waxed_copper_lantern": "打蠟的銅燈籠",
  "block.minecraft.waxed_copper_trapdoor": "打蠟的銅地板門",
  "block.minecraft.waxed_cut_copper": "打蠟的切製銅磚",
  "block.minecraft.waxed_cut_copper_slab": "打蠟的切製銅半磚",
  "block.minecraft.waxed_cut_copper_stairs": "打蠟的切製銅樓梯",
  "block.minecraft.waxed_exposed_chiseled_copper": "打蠟的斑駁浮雕銅磚",
  "block.minecraft.waxed_exposed_copper": "打蠟的斑駁銅磚",
  "block.minecraft.waxed_exposed_copper_bars": "打蠟的斑駁銅欄杆",
  "block.minecraft.waxed_exposed_copper_bulb": "打蠟的斑駁銅燈",
  "block.minecraft.waxed_exposed_copper_chain": "打蠟的斑駁銅鏈",
  "block.minecraft.waxed_exposed_copper_chest": "打蠟的斑駁銅儲物箱",
  "block.minecraft.waxed_exposed_copper_door": "打蠟的斑駁銅門",
  "block.minecraft.waxed_exposed_copper_golem_statue": "打蠟的斑駁銅人雕像",
  "block.minecraft.waxed_exposed_copper_grate": "打蠟的斑駁銅網格",
  "block.minecraft.waxed_exposed_copper_lantern": "打蠟的斑駁銅燈籠",
  "block.minecraft.waxed_exposed_copper_trapdoor": "打蠟的斑駁銅地板門",
  "block.minecraft.waxed_exposed_cut_copper": "打蠟的斑駁切製銅磚",
  "block.minecraft.waxed_exposed_cut_copper_slab": "打蠟的斑駁切製銅半磚",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "打蠟的斑駁切製銅樓梯",
  "block.minecraft.waxed_exposed_lightning_rod": "打蠟的斑駁避雷針",
  "block.minecraft.waxed_lightning_rod": "打蠟的避雷針",
  "block.minecraft.waxed_oxidized_chiseled_copper": "打蠟的氧化浮雕銅磚",
  "block.minecraft.waxed_oxidized_copper": "打蠟的氧化銅磚",
  "block.minecraft.waxed_oxidized_copper_bars": "打蠟的氧化銅欄杆",
  "block.minecraft.waxed_oxidized_copper_bulb": "打蠟的氧化銅燈",
  "block.minecraft.waxed_oxidized_copper_chain": "打蠟的氧化銅鏈",
  "block.minecraft.waxed_oxidized_copper_chest": "打蠟的氧化銅儲物箱",
  "block.minecraft.waxed_oxidized_copper_door": "打蠟的氧化銅門",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "打蠟的氧化銅人雕像",
  "block.minecraft.waxed_oxidized_copper_grate": "打蠟的氧化銅網格",
  "block.minecraft.waxed_oxidized_copper_lantern": "打蠟的氧化銅燈籠",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "打蠟的氧化銅地板門",
  "block.minecraft.waxed_oxidized_cut_copper": "打蠟的氧化切製銅磚",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "打蠟的氧化切製銅半磚",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "打蠟的氧化切製銅樓梯",
  "block.minecraft.waxed_oxidized_lightning_rod": "打蠟的氧化避雷針",
  "block.minecraft.waxed_weathered_chiseled_copper": "打蠟的生鏽浮雕銅磚",
  "block.minecraft.waxed_weathered_copper": "打蠟的生鏽銅磚",
  "block.minecraft.waxed_weathered_copper_bars": "打蠟的生鏽銅欄杆",
  "block.minecraft.waxed_weathered_copper_bulb": "打蠟的生鏽銅燈",
  "block.minecraft.waxed_weathered_copper_chain": "打蠟的生鏽銅鏈",
  "block.minecraft.waxed_weathered_copper_chest": "打蠟的生鏽銅儲物箱",
  "block.minecraft.waxed_weathered_copper_door": "打蠟的生鏽銅門",
  "block.minecraft.waxed_weathered_copper_golem_statue": "打蠟的生鏽銅人雕像",
  "block.minecraft.waxed_weathered_copper_grate": "打蠟的生鏽銅網格",
  "block.minecraft.waxed_weathered_copper_lantern": "打蠟的生鏽銅燈籠",
  "block.minecraft.waxed_weathered_copper_trapdoor": "打蠟的生鏽銅地板門",
  "block.minecraft.waxed_weathered_cut_copper": "打蠟的生鏽切製銅磚",
  "block.minecraft.waxed_weathered_cut_copper_slab": "打蠟的生鏽切製銅半磚",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "打蠟的生鏽切製銅樓梯",
  "block.minecraft.waxed_weathered_lightning_rod": "打蠟的生鏽避雷針",
  "block.minecraft.weathered_chiseled_copper": "生鏽的浮雕銅磚",
  "block.minecraft.weathered_copper": "生鏽的銅磚",
  "block.minecraft.weathered_copper_bars": "生鏽的銅欄杆",
  "block.minecraft.weathered_copper_bulb": "生鏽的銅燈",
  "block.minecraft.weathered_copper_chain": "生鏽的銅鏈",
  "block.minecraft.weathered_copper_chest": "生鏽的銅儲物箱",
  "block.minecraft.weathered_copper_door": "生鏽的銅門",
  "block.minecraft.weathered_copper_golem_statue": "生鏽的銅人雕像",
  "block.minecraft.weathered_copper_grate": "生鏽的銅網格",
  "block.minecraft.weathered_copper_lantern": "生鏽的銅燈籠",
  "block.minecraft.weathered_copper_trapdoor": "生鏽的銅地板門",
  "block.minecraft.weathered_cut_copper": "生鏽的切製銅磚",
  "block.minecraft.weathered_cut_copper_slab": "生鏽的切製銅半磚",
  "block.minecraft.weathered_cut_copper_stairs": "生鏽的切製銅樓梯",
  "block.minecraft.weathered_lightning_rod": "生鏽的避雷針",
  "block.minecraft.weeping_vines": "哭泣藤",
  "block.minecraft.weeping_vines_plant": "哭泣藤植株",
  "block.minecraft.wet_sponge": "濕海綿",
  "block.minecraft.wheat": "小麥植株",
  "block.minecraft.white_banner": "白色橫額",
  "block.minecraft.white_bed": "白色牀",
  "block.minecraft.white_candle": "白色蠟燭",
  "block.minecraft.white_candle_cake": "插上白色蠟燭的蛋糕",
  "block.minecraft.white_carpet": "白色地氈",
  "block.minecraft.white_concrete": "白色混凝土",
  "block.minecraft.white_concrete_powder": "白色混凝土粉末",
  "block.minecraft.white_glazed_terracotta": "白色釉陶",
  "block.minecraft.white_shulker_box": "白色界伏盒",
  "block.minecraft.white_stained_glass": "白色染色玻璃",
  "block.minecraft.white_stained_glass_pane": "白色染色玻璃片",
  "block.minecraft.white_terracotta": "白色陶瓦",
  "block.minecraft.white_tulip": "白色鬱金香",
  "block.minecraft.white_wool": "白色羊毛",
  "block.minecraft.wildflowers": "野花簇",
  "block.minecraft.wither_rose": "凋零玫瑰",
  "block.minecraft.wither_skeleton_skull": "凋零骷髏骨頭顱",
  "block.minecraft.wither_skeleton_wall_skull": "牆上的凋零骷髏骨頭顱",
  "block.minecraft.yellow_banner": "黃色橫額",
  "block.minecraft.yellow_bed": "黃色牀",
  "block.minecraft.yellow_candle": "黃色蠟燭",
  "block.minecraft.yellow_candle_cake": "插上黃色蠟燭的蛋糕",
  "block.minecraft.yellow_carpet": "黃色地氈",
  "block.minecraft.yellow_concrete": "黃色混凝土",
  "block.minecraft.yellow_concrete_powder": "黃色混凝土粉末",
  "block.minecraft.yellow_glazed_terracotta": "黃色釉陶",
  "block.minecraft.yellow_shulker_box": "黃色界伏盒",
  "block.minecraft.yellow_stained_glass": "黃色染色玻璃",
  "block.minecraft.yellow_stained_glass_pane": "黃色染色玻璃片",
  "block.minecraft.yellow_terracotta": "黃色陶瓦",
  "block.minecraft.yellow_wool": "黃色羊毛",
  "block.minecraft.zombie_head": "喪屍頭顱",
  "block.minecraft.zombie_wall_head": "牆上的喪屍頭顱",
  "item.minecraft.acacia_boat": "相思木船",
  "item.minecraft.acacia_chest_boat": "儲物箱相思木船",
  "item.minecraft.allay_spawn_egg": "悦靈生成蛋",
  "item.minecraft.amethyst_shard": "紫水晶碎片",
  "item.minecraft.angler_pottery_shard": "垂釣陶罐碎片",
  "item.minecraft.angler_pottery_sherd": "垂釣陶罐碎片",
  "item.minecraft.apple": "蘋果",
  "item.minecraft.archer_pottery_shard": "弓箭陶罐碎片",
  "item.minecraft.archer_pottery_sherd": "弓箭陶罐碎片",
  "item.minecraft.armadillo_scute": "犰狳鱗甲",
  "item.minecraft.armadillo_spawn_egg": "犰狳生成蛋",
  "item.minecraft.armor_stand": "盔甲座",
  "item.minecraft.arms_up_pottery_shard": "舉臂陶罐碎片",
  "item.minecraft.arms_up_pottery_sherd": "舉臂陶罐碎片",
  "item.minecraft.arrow": "箭",
  "item.minecraft.axolotl_bucket": "墨西哥蠑螈桶",
  "item.minecraft.axolotl_spawn_egg": "墨西哥蠑螈生成蛋",
  "item.minecraft.baked_potato": "焗薯仔",
  "item.minecraft.bamboo_chest_raft": "儲物箱竹筏",
  "item.minecraft.bamboo_raft": "竹筏",
  "item.minecraft.bat_spawn_egg": "蝙蝠生成蛋",
  "item.minecraft.bee_spawn_egg": "蜜蜂生成蛋",
  "item.minecraft.beef": "生牛肉",
  "item.minecraft.beetroot": "紅菜頭",
  "item.minecraft.beetroot_seeds": "紅菜頭種子",
  "item.minecraft.beetroot_soup": "紅菜頭湯",
  "item.minecraft.birch_boat": "樺木船",
  "item.minecraft.birch_chest_boat": "儲物箱樺木船",
  "item.minecraft.black_bundle": "黑色收納袋",
  "item.minecraft.black_dye": "黑色染料",
  "item.minecraft.black_harness": "黑色牽引器具",
  "item.minecraft.blade_pottery_shard": "利刃陶罐碎片",
  "item.minecraft.blade_pottery_sherd": "利刃陶罐碎片",
  "item.minecraft.blaze_powder": "烈焰粉",
  "item.minecraft.blaze_rod": "烈焰棒",
  "item.minecraft.blaze_spawn_egg": "烈焰使者生成蛋",
  "item.minecraft.blue_bundle": "藍色收納袋",
  "item.minecraft.blue_dye": "藍色染料",
  "item.minecraft.blue_egg": "藍色雞蛋",
  "item.minecraft.blue_harness": "藍色牽引器具",
  "item.minecraft.bogged_spawn_egg": "沼骨生成蛋",
  "item.minecraft.bolt_armor_trim_smithing_template": "鍛造模板",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "緊固盔甲紋飾",
  "item.minecraft.bone": "骨頭",
  "item.minecraft.bone_meal": "骨粉",
  "item.minecraft.book": "書",
  "item.minecraft.bordure_indented_banner_pattern": "鋸齒邊橫額圖案",
  "item.minecraft.bow": "弓",
  "item.minecraft.bowl": "碗",
  "item.minecraft.bread": "麪包",
  "item.minecraft.breeze_rod": "旋風棒",
  "item.minecraft.breeze_spawn_egg": "旋風使者生成蛋",
  "item.minecraft.brewer_pottery_shard": "佳釀陶罐碎片",
  "item.minecraft.brewer_pottery_sherd": "佳釀陶罐碎片",
  "item.minecraft.brewing_stand": "釀造台",
  "item.minecraft.brick": "紅磚頭",
  "item.minecraft.brown_bundle": "啡色收納袋",
  "item.minecraft.brown_dye": "啡色染料",
  "item.minecraft.brown_egg": "啡色雞蛋",
  "item.minecraft.brown_harness": "啡色牽引器具",
  "item.minecraft.brush": "毛刷",
  "item.minecraft.bucket": "鐵桶",
  "item.minecraft.bundle": "收納袋",
  "item.minecraft.bundle.empty": "空",
  "item.minecraft.bundle.empty.description": "可以裝入混合的一組物品",
  "item.minecraft.bundle.full": "滿",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "烈焰陶罐碎片",
  "item.minecraft.burn_pottery_sherd": "烈焰陶罐碎片",
  "item.minecraft.camel_husk_spawn_egg": "駱駝屍殼生成蛋",
  "item.minecraft.camel_spawn_egg": "駱駝生成蛋",
  "item.minecraft.carrot": "紅蘿蔔",
  "item.minecraft.carrot_on_a_stick": "紅蘿蔔魚竿",
  "item.minecraft.cat_spawn_egg": "貓生成蛋",
  "item.minecraft.cauldron": "鍋",
  "item.minecraft.cave_spider_spawn_egg": "洞穴蜘蛛生成蛋",
  "item.minecraft.chainmail_boots": "鎖鏈靴",
  "item.minecraft.chainmail_chestplate": "鎖鏈胸甲",
  "item.minecraft.chainmail_helmet": "鎖鏈頭盔",
  "item.minecraft.chainmail_leggings": "鎖鏈護腳",
  "item.minecraft.charcoal": "木炭",
  "item.minecraft.cherry_boat": "櫻花木船",
  "item.minecraft.cherry_chest_boat": "儲物箱櫻花木船",
  "item.minecraft.chest_minecart": "儲物箱礦車",
  "item.minecraft.chicken": "生雞肉",
  "item.minecraft.chicken_spawn_egg": "雞生成蛋",
  "item.minecraft.chorus_fruit": "歌萊果",
  "item.minecraft.clay_ball": "黏土球",
  "item.minecraft.clock": "時鐘",
  "item.minecraft.coal": "煤炭",
  "item.minecraft.coast_armor_trim_smithing_template": "鍛造模板",
  "item.minecraft.coast_armor_trim_smithing_template.new": "海岸盔甲紋飾",
  "item.minecraft.cocoa_beans": "可可豆",
  "item.minecraft.cod": "生鱈魚",
  "item.minecraft.cod_bucket": "鱈魚桶",
  "item.minecraft.cod_spawn_egg": "鱈魚生成蛋",
  "item.minecraft.command_block_minecart": "命令方塊礦車",
  "item.minecraft.compass": "指南針",
  "item.minecraft.cooked_beef": "牛扒",
  "item.minecraft.cooked_chicken": "熟雞肉",
  "item.minecraft.cooked_cod": "熟鱈魚",
  "item.minecraft.cooked_mutton": "熟羊肉",
  "item.minecraft.cooked_porkchop": "熟豬扒",
  "item.minecraft.cooked_rabbit": "熟兔肉",
  "item.minecraft.cooked_salmon": "熟三文魚",
  "item.minecraft.cookie": "曲奇",
  "item.minecraft.copper_axe": "銅斧頭",
  "item.minecraft.copper_boots": "銅靴",
  "item.minecraft.copper_chestplate": "銅胸甲",
  "item.minecraft.copper_golem_spawn_egg": "銅人生成蛋",
  "item.minecraft.copper_helmet": "銅頭盔",
  "item.minecraft.copper_hoe": "銅鋤頭",
  "item.minecraft.copper_horse_armor": "銅馬甲",
  "item.minecraft.copper_ingot": "銅錠",
  "item.minecraft.copper_leggings": "銅護腳",
  "item.minecraft.copper_nautilus_armor": "銅鸚鵡螺甲",
  "item.minecraft.copper_nugget": "銅粒",
  "item.minecraft.copper_pickaxe": "銅鎬",
  "item.minecraft.copper_shovel": "銅鏟",
  "item.minecraft.copper_spear": "銅矛",
  "item.minecraft.copper_sword": "銅劍",
  "item.minecraft.cow_spawn_egg": "牛生成蛋",
  "item.minecraft.creaking_spawn_egg": "異響樹妖生成蛋",
  "item.minecraft.creeper_banner_pattern": "橫額圖案",
  "item.minecraft.creeper_banner_pattern.desc": "Creeper 圖案",
  "item.minecraft.creeper_banner_pattern.new": "Creeper 橫額圖案",
  "item.minecraft.creeper_spawn_egg": "Creeper 生成蛋",
  "item.minecraft.crossbow": "弩",
  "item.minecraft.crossbow.projectile": "投射物：",
  "item.minecraft.crossbow.projectile.multiple": "投射物：%s × %s",
  "item.minecraft.crossbow.projectile.single": "投射物：%s",
  "item.minecraft.cyan_bundle": "青藍色收納袋",
  "item.minecraft.cyan_dye": "青藍色染料",
  "item.minecraft.cyan_harness": "青藍色牽引器具",
  "item.minecraft.danger_pottery_shard": "危機陶罐碎片",
  "item.minecraft.danger_pottery_sherd": "危機陶罐碎片",
  "item.minecraft.dark_oak_boat": "黑橡木船",
  "item.minecraft.dark_oak_chest_boat": "儲物箱黑橡木船",
  "item.minecraft.debug_stick": "除錯棒",
  "item.minecraft.debug_stick.empty": "%s 沒有屬性",
  "item.minecraft.debug_stick.select": "已選擇 「%s」（%s）",
  "item.minecraft.debug_stick.update": "將 \"%s\" 設為 %s",
  "item.minecraft.diamond": "鑽石",
  "item.minecraft.diamond_axe": "鑽石斧頭",
  "item.minecraft.diamond_boots": "鑽石靴",
  "item.minecraft.diamond_chestplate": "鑽石胸甲",
  "item.minecraft.diamond_helmet": "鑽石頭盔",
  "item.minecraft.diamond_hoe": "鑽石鋤頭",
  "item.minecraft.diamond_horse_armor": "鑽石馬甲",
  "item.minecraft.diamond_leggings": "鑽石護腳",
  "item.minecraft.diamond_nautilus_armor": "鑽石鸚鵡螺甲",
  "item.minecraft.diamond_pickaxe": "鑽石鎬",
  "item.minecraft.diamond_shovel": "鑽石鏟",
  "item.minecraft.diamond_spear": "鑽石矛",
  "item.minecraft.diamond_sword": "鑽石劍",
  "item.minecraft.disc_fragment_5": "唱片殘片",
  "item.minecraft.disc_fragment_5.desc": "唱片 - 5",
  "item.minecraft.dolphin_spawn_egg": "海豚生成蛋",
  "item.minecraft.donkey_spawn_egg": "驢生成蛋",
  "item.minecraft.dragon_breath": "龍之吐息",
  "item.minecraft.dried_kelp": "乾海帶",
  "item.minecraft.drowned_spawn_egg": "沉屍生成蛋",
  "item.minecraft.dune_armor_trim_smithing_template": "鍛造模板",
  "item.minecraft.dune_armor_trim_smithing_template.new": "沙丘盔甲紋飾",
  "item.minecraft.echo_shard": "迴響碎片",
  "item.minecraft.egg": "雞蛋",
  "item.minecraft.elder_guardian_spawn_egg": "遠古深海守衞生成蛋",
  "item.minecraft.elytra": "鞘翅",
  "item.minecraft.emerald": "綠寶石",
  "item.minecraft.enchanted_book": "附魔書",
  "item.minecraft.enchanted_golden_apple": "附魔金蘋果",
  "item.minecraft.end_crystal": "終界水晶",
  "item.minecraft.ender_dragon_spawn_egg": "終界龍生成蛋",
  "item.minecraft.ender_eye": "終界之眼",
  "item.minecraft.ender_pearl": "終界珍珠",
  "item.minecraft.enderman_spawn_egg": "終界使者生成蛋",
  "item.minecraft.endermite_spawn_egg": "終界蟎生成蛋",
  "item.minecraft.evoker_spawn_egg": "喚魔者生成蛋",
  "item.minecraft.experience_bottle": "附魔之瓶",
  "item.minecraft.explorer_pottery_shard": "探險陶罐碎片",
  "item.minecraft.explorer_pottery_sherd": "探險陶罐碎片",
  "item.minecraft.eye_armor_trim_smithing_template": "鍛造模板",
  "item.minecraft.eye_armor_trim_smithing_template.new": "眼眸盔甲紋飾",
  "item.minecraft.feather": "羽毛",
  "item.minecraft.fermented_spider_eye": "發酵蜘蛛眼",
  "item.minecraft.field_masoned_banner_pattern": "磚牆花紋橫額圖案",
  "item.minecraft.filled_map": "地圖",
  "item.minecraft.fire_charge": "火焰彈",
  "item.minecraft.firework_rocket": "煙花",
  "item.minecraft.firework_rocket.flight": "飛行時間：",
  "item.minecraft.firework_rocket.multiple_stars": "%s × %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "煙花球",
  "item.minecraft.firework_star.black": "黑色",
  "item.minecraft.firework_star.blue": "藍色",
  "item.minecraft.firework_star.brown": "啡色",
  "item.minecraft.firework_star.custom_color": "自訂",
  "item.minecraft.firework_star.cyan": "青藍色",
  "item.minecraft.firework_star.fade_to": "淡出",
  "item.minecraft.firework_star.flicker": "閃爍",
  "item.minecraft.firework_star.gray": "灰色",
  "item.minecraft.firework_star.green": "綠色",
  "item.minecraft.firework_star.light_blue": "淺藍色",
  "item.minecraft.firework_star.light_gray": "淺灰色",
  "item.minecraft.firework_star.lime": "淺綠色",
  "item.minecraft.firework_star.magenta": "紫紅色",
  "item.minecraft.firework_star.orange": "橙色",
  "item.minecraft.firework_star.pink": "粉紅色",
  "item.minecraft.firework_star.purple": "紫色",
  "item.minecraft.firework_star.red": "紅色",
  "item.minecraft.firework_star.shape": "未知形狀",
  "item.minecraft.firework_star.shape.burst": "爆裂",
  "item.minecraft.firework_star.shape.creeper": "Creeper 形",
  "item.minecraft.firework_star.shape.large_ball": "大型球狀",
  "item.minecraft.firework_star.shape.small_ball": "小型球狀",
  "item.minecraft.firework_star.shape.star": "星形",
  "item.minecraft.firework_star.trail": "軌跡",
  "item.minecraft.firework_star.white": "白色",
  "item.minecraft.firework_star.yellow": "黃色",
  "item.minecraft.fishing_rod": "魚竿",
  "item.minecraft.flint": "燧石",
  "item.minecraft.flint_and_steel": "打火石",
  "item.minecraft.flow_armor_trim_smithing_template": "鍛造模板",
  "item.minecraft.flow_armor_trim_smithing_template.new": "渦流盔甲紋飾",
  "item.minecraft.flow_banner_pattern": "橫額圖案",
  "item.minecraft.flow_banner_pattern.desc": "渦流",
  "item.minecraft.flow_banner_pattern.new": "渦流橫額圖案",
  "item.minecraft.flow_pottery_sherd": "渦流陶罐碎片",
  "item.minecraft.flower_banner_pattern": "橫額圖案",
  "item.minecraft.flower_banner_pattern.desc": "花朵圖案",
  "item.minecraft.flower_banner_pattern.new": "花朵橫額圖案",
  "item.minecraft.flower_pot": "花盆",
  "item.minecraft.fox_spawn_egg": "狐狸生成蛋",
  "item.minecraft.friend_pottery_shard": "朋友陶罐碎片",
  "item.minecraft.friend_pottery_sherd": "朋友陶罐碎片",
  "item.minecraft.frog_spawn_egg": "青蛙生成蛋",
  "item.minecraft.furnace_minecart": "熔爐礦車",
  "item.minecraft.ghast_spawn_egg": "地獄幽靈生成蛋",
  "item.minecraft.ghast_tear": "幽靈之淚",
  "item.minecraft.glass_bottle": "玻璃樽",
  "item.minecraft.glistering_melon_slice": "鑲金西瓜片",
  "item.minecraft.globe_banner_pattern": "橫額圖案",
  "item.minecraft.globe_banner_pattern.desc": "地球",
  "item.minecraft.globe_banner_pattern.new": "地球橫額圖案",
  "item.minecraft.glow_berries": "熒光莓",
  "item.minecraft.glow_ink_sac": "熒光墨囊",
  "item.minecraft.glow_item_frame": "熒光物品展示框",
  "item.minecraft.glow_squid_spawn_egg": "熒光墨魚生成蛋",
  "item.minecraft.glowstone_dust": "熒光石粉",
  "item.minecraft.goat_horn": "山羊角",
  "item.minecraft.goat_spawn_egg": "山羊生成蛋",
  "item.minecraft.gold_ingot": "金錠",
  "item.minecraft.gold_nugget": "金粒",
  "item.minecraft.golden_apple": "金蘋果",
  "item.minecraft.golden_axe": "金斧頭",
  "item.minecraft.golden_boots": "金靴",
  "item.minecraft.golden_carrot": "金紅蘿蔔",
  "item.minecraft.golden_chestplate": "金胸甲",
  "item.minecraft.golden_helmet": "金頭盔",
  "item.minecraft.golden_hoe": "金鋤頭",
  "item.minecraft.golden_horse_armor": "金馬甲",
  "item.minecraft.golden_leggings": "金護腳",
  "item.minecraft.golden_nautilus_armor": "金鸚鵡螺甲",
  "item.minecraft.golden_pickaxe": "金鎬",
  "item.minecraft.golden_shovel": "金鏟",
  "item.minecraft.golden_spear": "金矛",
  "item.minecraft.golden_sword": "金劍",
  "item.minecraft.gray_bundle": "灰色收納袋",
  "item.minecraft.gray_dye": "灰色染料",
  "item.minecraft.gray_harness": "灰色牽引器具",
  "item.minecraft.green_bundle": "綠色收納袋",
  "item.minecraft.green_dye": "綠色染料",
  "item.minecraft.green_harness": "綠色牽引器具",
  "item.minecraft.guardian_spawn_egg": "深海守衞生成蛋",
  "item.minecraft.gunpowder": "火藥",
  "item.minecraft.guster_banner_pattern": "橫額圖案",
  "item.minecraft.guster_banner_pattern.desc": "旋風",
  "item.minecraft.guster_banner_pattern.new": "旋風橫額圖案",
  "item.minecraft.guster_pottery_sherd": "旋風陶罐碎片",
  "item.minecraft.happy_ghast_spawn_egg": "快樂幽靈生成蛋",
  "item.minecraft.harness": "牽引器具",
  "item.minecraft.heart_of_the_sea": "海洋之心",
  "item.minecraft.heart_pottery_shard": "愛心陶罐碎片",
  "item.minecraft.heart_pottery_sherd": "愛心陶罐碎片",
  "item.minecraft.heartbreak_pottery_shard": "心碎陶罐碎片",
  "item.minecraft.heartbreak_pottery_sherd": "心碎陶罐碎片",
  "item.minecraft.hoglin_spawn_egg": "野豬獸生成蛋",
  "item.minecraft.honey_bottle": "蜜糖樽",
  "item.minecraft.honeycomb": "蜂巢蜜",
  "item.minecraft.hopper_minecart": "漏斗礦車",
  "item.minecraft.horse_spawn_egg": "馬生成蛋",
  "item.minecraft.host_armor_trim_smithing_template": "鍛造模板",
  "item.minecraft.host_armor_trim_smithing_template.new": "僱主盔甲紋飾",
  "item.minecraft.howl_pottery_shard": "狼嚎陶罐碎片",
  "item.minecraft.howl_pottery_sherd": "狼嚎陶罐碎片",
  "item.minecraft.husk_spawn_egg": "屍殼生成蛋",
  "item.minecraft.ink_sac": "墨囊",
  "item.minecraft.iron_axe": "鐵斧頭",
  "item.minecraft.iron_boots": "鐵靴",
  "item.minecraft.iron_chestplate": "鐵胸甲",
  "item.minecraft.iron_golem_spawn_egg": "鐵人生成蛋",
  "item.minecraft.iron_helmet": "鐵頭盔",
  "item.minecraft.iron_hoe": "鐵鋤頭",
  "item.minecraft.iron_horse_armor": "鐵馬甲",
  "item.minecraft.iron_ingot": "鐵錠",
  "item.minecraft.iron_leggings": "鐵護腳",
  "item.minecraft.iron_nautilus_armor": "鐵鸚鵡螺甲",
  "item.minecraft.iron_nugget": "鐵粒",
  "item.minecraft.iron_pickaxe": "鐵鎬",
  "item.minecraft.iron_shovel": "鐵鏟",
  "item.minecraft.iron_spear": "鐵矛",
  "item.minecraft.iron_sword": "鐵劍",
  "item.minecraft.item_frame": "物品展示框",
  "item.minecraft.jungle_boat": "叢林木船",
  "item.minecraft.jungle_chest_boat": "儲物箱叢林木船",
  "item.minecraft.knowledge_book": "知識之書",
  "item.minecraft.lapis_lazuli": "青金石",
  "item.minecraft.lava_bucket": "熔巖桶",
  "item.minecraft.lead": "牽繩",
  "item.minecraft.leather": "皮革",
  "item.minecraft.leather_boots": "皮革靴",
  "item.minecraft.leather_chestplate": "皮革衫",
  "item.minecraft.leather_helmet": "皮革帽",
  "item.minecraft.leather_horse_armor": "皮革馬甲",
  "item.minecraft.leather_leggings": "皮革褲",
  "item.minecraft.light_blue_bundle": "淺藍色收納袋",
  "item.minecraft.light_blue_dye": "淺藍色染料",
  "item.minecraft.light_blue_harness": "淺藍色牽引器具",
  "item.minecraft.light_gray_bundle": "淺灰色收納袋",
  "item.minecraft.light_gray_dye": "淺灰色染料",
  "item.minecraft.light_gray_harness": "淺灰色牽引器具",
  "item.minecraft.lime_bundle": "淺綠色收納袋",
  "item.minecraft.lime_dye": "淺綠色染料",
  "item.minecraft.lime_harness": "淺綠色牽引器具",
  "item.minecraft.lingering_potion": "滯留藥水",
  "item.minecraft.lingering_potion.effect.awkward": "滯留型粗製藥水",
  "item.minecraft.lingering_potion.effect.empty": "滯留型不可合成的藥水",
  "item.minecraft.lingering_potion.effect.fire_resistance": "滯留型抗火藥水",
  "item.minecraft.lingering_potion.effect.harming": "滯留型傷害藥水",
  "item.minecraft.lingering_potion.effect.healing": "滯留型治療藥水",
  "item.minecraft.lingering_potion.effect.infested": "滯留型蛀蝕藥水",
  "item.minecraft.lingering_potion.effect.invisibility": "滯留型隱形藥水",
  "item.minecraft.lingering_potion.effect.leaping": "滯留型跳躍藥水",
  "item.minecraft.lingering_potion.effect.levitation": "滯留型飄浮藥水",
  "item.minecraft.lingering_potion.effect.luck": "滯留型幸運藥水",
  "item.minecraft.lingering_potion.effect.mundane": "滯留型平凡藥水",
  "item.minecraft.lingering_potion.effect.night_vision": "滯留型夜視藥水",
  "item.minecraft.lingering_potion.effect.oozing": "滯留型滲漿藥水",
  "item.minecraft.lingering_potion.effect.poison": "滯留型劇毒藥水",
  "item.minecraft.lingering_potion.effect.regeneration": "滯留型回復藥水",
  "item.minecraft.lingering_potion.effect.slow_falling": "滯留型緩降藥水",
  "item.minecraft.lingering_potion.effect.slowness": "滯留型緩速藥水",
  "item.minecraft.lingering_potion.effect.strength": "滯留型力量藥水",
  "item.minecraft.lingering_potion.effect.swiftness": "滯留型迅捷藥水",
  "item.minecraft.lingering_potion.effect.thick": "滯留型黏稠藥水",
  "item.minecraft.lingering_potion.effect.turtle_master": "滯留型神龜藥水",
  "item.minecraft.lingering_potion.effect.water": "滯留型水樽",
  "item.minecraft.lingering_potion.effect.water_breathing": "滯留型水中呼吸藥水",
  "item.minecraft.lingering_potion.effect.weakness": "滯留型虛弱藥水",
  "item.minecraft.lingering_potion.effect.weaving": "滯留型織網藥水",
  "item.minecraft.lingering_potion.effect.wind_charged": "滯留型蓄風藥水",
  "item.minecraft.llama_spawn_egg": "羊駝生成蛋",
  "item.minecraft.lodestone_compass": "磁石指南針",
  "item.minecraft.mace": "重錘",
  "item.minecraft.magenta_bundle": "紫紅色收納袋",
  "item.minecraft.magenta_dye": "紫紅色染料",
  "item.minecraft.magenta_harness": "紫紅色牽引器具",
  "item.minecraft.magma_cream": "巖漿球",
  "item.minecraft.magma_cube_spawn_egg": "巖漿史萊姆生成蛋",
  "item.minecraft.mangrove_boat": "紅樹木船",
  "item.minecraft.mangrove_chest_boat": "儲物箱紅樹木船",
  "item.minecraft.map": "空白地圖",
  "item.minecraft.melon_seeds": "西瓜種子",
  "item.minecraft.melon_slice": "西瓜片",
  "item.minecraft.milk_bucket": "鮮奶桶",
  "item.minecraft.minecart": "礦車",
  "item.minecraft.miner_pottery_shard": "採礦陶罐碎片",
  "item.minecraft.miner_pottery_sherd": "採礦陶罐碎片",
  "item.minecraft.mojang_banner_pattern": "橫額圖案",
  "item.minecraft.mojang_banner_pattern.desc": "Mojang 標誌",
  "item.minecraft.mojang_banner_pattern.new": "Mojang 標誌橫額圖案",
  "item.minecraft.mooshroom_spawn_egg": "蘑菇牛生成蛋",
  "item.minecraft.mourner_pottery_shard": "悲慟陶罐碎片",
  "item.minecraft.mourner_pottery_sherd": "悲慟陶罐碎片",
  "item.minecraft.mule_spawn_egg": "騾生成蛋",
  "item.minecraft.mushroom_stew": "蘑菇湯",
  "item.minecraft.music_disc_11": "唱片",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "唱片",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "唱片",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "唱片",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "唱片",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "唱片",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "唱片",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "唱片",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Creator（音樂盒）",
  "item.minecraft.music_disc_far": "唱片",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "唱片",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "唱片",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "唱片",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "唱片",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - otherside",
  "item.minecraft.music_disc_pigstep": "唱片",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - Pigstep",
  "item.minecraft.music_disc_precipice": "唱片",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "唱片",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - Relic",
  "item.minecraft.music_disc_stal": "唱片",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "唱片",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "唱片",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "唱片",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "唱片",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "生羊肉",
  "item.minecraft.name_tag": "命名牌",
  "item.minecraft.nautilus_shell": "鸚鵡螺殼",
  "item.minecraft.nautilus_spawn_egg": "鸚鵡螺生成蛋",
  "item.minecraft.nether_brick": "地獄磚頭",
  "item.minecraft.nether_star": "地獄之星",
  "item.minecraft.nether_wart": "地獄孢子",
  "item.minecraft.netherite_axe": "地獄合金斧頭",
  "item.minecraft.netherite_boots": "地獄合金靴",
  "item.minecraft.netherite_chestplate": "地獄合金胸甲",
  "item.minecraft.netherite_helmet": "地獄合金頭盔",
  "item.minecraft.netherite_hoe": "地獄合金鋤頭",
  "item.minecraft.netherite_horse_armor": "地獄合金馬甲",
  "item.minecraft.netherite_ingot": "地獄合金錠",
  "item.minecraft.netherite_leggings": "地獄合金護腳",
  "item.minecraft.netherite_nautilus_armor": "地獄合金鸚鵡螺甲",
  "item.minecraft.netherite_pickaxe": "地獄合金鎬",
  "item.minecraft.netherite_scrap": "地獄合金碎片",
  "item.minecraft.netherite_shovel": "地獄合金鏟",
  "item.minecraft.netherite_spear": "地獄合金矛",
  "item.minecraft.netherite_sword": "地獄合金劍",
  "item.minecraft.netherite_upgrade_smithing_template": "鍛造模板",
  "item.minecraft.netherite_upgrade_smithing_template.new": "地獄合金升級",
  "item.minecraft.oak_boat": "橡木船",
  "item.minecraft.oak_chest_boat": "儲物箱橡木船",
  "item.minecraft.ocelot_spawn_egg": "豹貓生成蛋",
  "item.minecraft.ominous_bottle": "不祥之瓶",
  "item.minecraft.ominous_trial_key": "不祥試煉鎖匙",
  "item.minecraft.orange_bundle": "橙色收納袋",
  "item.minecraft.orange_dye": "橙色染料",
  "item.minecraft.orange_harness": "橙色牽引器具",
  "item.minecraft.painting": "畫",
  "item.minecraft.pale_oak_boat": "蒼白橡木船",
  "item.minecraft.pale_oak_chest_boat": "儲物箱蒼白橡木船",
  "item.minecraft.panda_spawn_egg": "熊貓生成蛋",
  "item.minecraft.paper": "紙",
  "item.minecraft.parched_spawn_egg": "旱骨生成蛋",
  "item.minecraft.parrot_spawn_egg": "鸚鵡生成蛋",
  "item.minecraft.phantom_membrane": "夜魅膜",
  "item.minecraft.phantom_spawn_egg": "夜魅生成蛋",
  "item.minecraft.pig_spawn_egg": "豬生成蛋",
  "item.minecraft.piglin_banner_pattern": "橫額圖案",
  "item.minecraft.piglin_banner_pattern.desc": "豬鼻",
  "item.minecraft.piglin_banner_pattern.new": "豬鼻橫額圖案",
  "item.minecraft.piglin_brute_spawn_egg": "殘暴豬人生成蛋",
  "item.minecraft.piglin_spawn_egg": "豬人生成蛋",
  "item.minecraft.pillager_spawn_egg": "掠奪者生成蛋",
  "item.minecraft.pink_bundle": "粉紅色收納袋",
  "item.minecraft.pink_dye": "粉紅色染料",
  "item.minecraft.pink_harness": "粉紅色牽引器具",
  "item.minecraft.pitcher_plant": "樽草",
  "item.minecraft.pitcher_pod": "樽草莢果",
  "item.minecraft.plenty_pottery_shard": "富饒陶罐碎片",
  "item.minecraft.plenty_pottery_sherd": "富饒陶罐碎片",
  "item.minecraft.poisonous_potato": "毒薯仔",
  "item.minecraft.polar_bear_spawn_egg": "北極熊生成蛋",
  "item.minecraft.popped_chorus_fruit": "爆開的歌萊果",
  "item.minecraft.porkchop": "生豬扒",
  "item.minecraft.potato": "薯仔",
  "item.minecraft.potion": "藥水",
  "item.minecraft.potion.effect.awkward": "粗製藥水",
  "item.minecraft.potion.effect.empty": "不可合成的藥水",
  "item.minecraft.potion.effect.fire_resistance": "抗火藥水",
  "item.minecraft.potion.effect.harming": "傷害藥水",
  "item.minecraft.potion.effect.healing": "治療藥水",
  "item.minecraft.potion.effect.infested": "蛀蝕藥水",
  "item.minecraft.potion.effect.invisibility": "隱形藥水",
  "item.minecraft.potion.effect.leaping": "跳躍藥水",
  "item.minecraft.potion.effect.levitation": "飄浮藥水",
  "item.minecraft.potion.effect.luck": "幸運藥水",
  "item.minecraft.potion.effect.mundane": "平凡藥水",
  "item.minecraft.potion.effect.night_vision": "夜視藥水",
  "item.minecraft.potion.effect.oozing": "滲漿藥水",
  "item.minecraft.potion.effect.poison": "劇毒藥水",
  "item.minecraft.potion.effect.regeneration": "回復藥水",
  "item.minecraft.potion.effect.slow_falling": "緩降藥水",
  "item.minecraft.potion.effect.slowness": "緩速藥水",
  "item.minecraft.potion.effect.strength": "力量藥水",
  "item.minecraft.potion.effect.swiftness": "迅捷藥水",
  "item.minecraft.potion.effect.thick": "黏稠藥水",
  "item.minecraft.potion.effect.turtle_master": "神龜藥水",
  "item.minecraft.potion.effect.water": "水樽",
  "item.minecraft.potion.effect.water_breathing": "水中呼吸藥水",
  "item.minecraft.potion.effect.weakness": "虛弱藥水",
  "item.minecraft.potion.effect.weaving": "織網藥水",
  "item.minecraft.potion.effect.wind_charged": "蓄風藥水",
  "item.minecraft.pottery_shard_archer": "弓箭陶罐碎片",
  "item.minecraft.pottery_shard_arms_up": "舉臂陶罐碎片",
  "item.minecraft.pottery_shard_prize": "珍寶陶罐碎片",
  "item.minecraft.pottery_shard_skull": "頭顱陶罐碎片",
  "item.minecraft.powder_snow_bucket": "幼雪桶",
  "item.minecraft.prismarine_crystals": "海磷晶體",
  "item.minecraft.prismarine_shard": "海磷碎片",
  "item.minecraft.prize_pottery_shard": "珍寶陶罐碎片",
  "item.minecraft.prize_pottery_sherd": "珍寶陶罐碎片",
  "item.minecraft.pufferfish": "河豚",
  "item.minecraft.pufferfish_bucket": "河豚桶",
  "item.minecraft.pufferfish_spawn_egg": "河豚生成蛋",
  "item.minecraft.pumpkin_pie": "南瓜批",
  "item.minecraft.pumpkin_seeds": "南瓜種子",
  "item.minecraft.purple_bundle": "紫色收納袋",
  "item.minecraft.purple_dye": "紫色染料",
  "item.minecraft.purple_harness": "紫色牽引器具",
  "item.minecraft.quartz": "地獄石英",
  "item.minecraft.rabbit": "生兔肉",
  "item.minecraft.rabbit_foot": "兔腳",
  "item.minecraft.rabbit_hide": "兔皮",
  "item.minecraft.rabbit_spawn_egg": "兔生成蛋",
  "item.minecraft.rabbit_stew": "兔肉湯",
  "item.minecraft.raiser_armor_trim_smithing_template": "鍛造模板",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "牧民盔甲紋飾",
  "item.minecraft.ravager_spawn_egg": "劫毀獸生成蛋",
  "item.minecraft.raw_copper": "粗銅",
  "item.minecraft.raw_gold": "粗金",
  "item.minecraft.raw_iron": "粗鐵",
  "item.minecraft.recovery_compass": "追溯指南針",
  "item.minecraft.red_bundle": "紅色收納袋",
  "item.minecraft.red_dye": "紅色染料",
  "item.minecraft.red_harness": "紅色牽引器具",
  "item.minecraft.redstone": "紅石粉",
  "item.minecraft.resin_brick": "樹脂磚頭",
  "item.minecraft.resin_clump": "樹脂團",
  "item.minecraft.rib_armor_trim_smithing_template": "鍛造模板",
  "item.minecraft.rib_armor_trim_smithing_template.new": "肋骨盔甲紋飾",
  "item.minecraft.rotten_flesh": "腐肉",
  "item.minecraft.saddle": "鞍",
  "item.minecraft.salmon": "生三文魚",
  "item.minecraft.salmon_bucket": "三文魚桶",
  "item.minecraft.salmon_spawn_egg": "三文魚生成蛋",
  "item.minecraft.scrape_pottery_sherd": "刮削陶罐碎片",
  "item.minecraft.scute": "鱗甲",
  "item.minecraft.sentry_armor_trim_smithing_template": "鍛造模板",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "哨兵盔甲紋飾",
  "item.minecraft.shaper_armor_trim_smithing_template": "鍛造模板",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "塑造盔甲紋飾",
  "item.minecraft.sheaf_pottery_shard": "麥捆陶罐碎片",
  "item.minecraft.sheaf_pottery_sherd": "麥捆陶罐碎片",
  "item.minecraft.shears": "剪刀",
  "item.minecraft.sheep_spawn_egg": "綿羊生成蛋",
  "item.minecraft.shelter_pottery_shard": "樹蔭陶罐碎片",
  "item.minecraft.shelter_pottery_sherd": "樹蔭陶罐碎片",
  "item.minecraft.shield": "盾牌",
  "item.minecraft.shield.black": "黑色盾牌",
  "item.minecraft.shield.blue": "藍色盾牌",
  "item.minecraft.shield.brown": "啡色盾牌",
  "item.minecraft.shield.cyan": "青藍色盾牌",
  "item.minecraft.shield.gray": "灰色盾牌",
  "item.minecraft.shield.green": "綠色盾牌",
  "item.minecraft.shield.light_blue": "淺藍色盾牌",
  "item.minecraft.shield.light_gray": "淺灰色盾牌",
  "item.minecraft.shield.lime": "淺綠色盾牌",
  "item.minecraft.shield.magenta": "紫紅色盾牌",
  "item.minecraft.shield.orange": "橙色盾牌",
  "item.minecraft.shield.pink": "粉紅色盾牌",
  "item.minecraft.shield.purple": "紫色盾牌",
  "item.minecraft.shield.red": "紅色盾牌",
  "item.minecraft.shield.white": "白色盾牌",
  "item.minecraft.shield.yellow": "黃色盾牌",
  "item.minecraft.shulker_shell": "界伏殼",
  "item.minecraft.shulker_spawn_egg": "界伏蚌生成蛋",
  "item.minecraft.sign": "指示牌",
  "item.minecraft.silence_armor_trim_smithing_template": "鍛造模板",
  "item.minecraft.silence_armor_trim_smithing_template.new": "沉靜盔甲紋飾",
  "item.minecraft.silverfish_spawn_egg": "蠹魚生成蛋",
  "item.minecraft.skeleton_horse_spawn_egg": "骷髏骨馬生成蛋",
  "item.minecraft.skeleton_spawn_egg": "骷髏骨生成蛋",
  "item.minecraft.skull_banner_pattern": "橫額圖案",
  "item.minecraft.skull_banner_pattern.desc": "骷髏骨圖案",
  "item.minecraft.skull_banner_pattern.new": "骷髏骨橫額圖案",
  "item.minecraft.skull_pottery_shard": "頭顱陶罐碎片",
  "item.minecraft.skull_pottery_sherd": "頭顱陶罐碎片",
  "item.minecraft.slime_ball": "史萊姆球",
  "item.minecraft.slime_spawn_egg": "史萊姆生成蛋",
  "item.minecraft.smithing_template": "鍛造模板",
  "item.minecraft.smithing_template.applies_to": "可套用於：",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "放入錠或晶體",
  "item.minecraft.smithing_template.armor_trim.applies_to": "盔甲",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "放入盔甲",
  "item.minecraft.smithing_template.armor_trim.ingredients": "錠或晶體",
  "item.minecraft.smithing_template.ingredients": "所需原材料：",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "放入地獄合金錠",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "鑽石裝備",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "放入鑽石盔甲、武器或工具",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "地獄合金錠",
  "item.minecraft.smithing_template.upgrade": "已有升級： ",
  "item.minecraft.sniffer_spawn_egg": "嗅探獸生成蛋",
  "item.minecraft.snort_pottery_shard": "嗅探陶罐碎片",
  "item.minecraft.snort_pottery_sherd": "嗅探陶罐碎片",
  "item.minecraft.snout_armor_trim_smithing_template": "鍛造模板",
  "item.minecraft.snout_armor_trim_smithing_template.new": "豬鼻盔甲紋飾",
  "item.minecraft.snow_golem_spawn_egg": "雪人生成蛋",
  "item.minecraft.snowball": "雪球",
  "item.minecraft.spectral_arrow": "追跡之箭",
  "item.minecraft.spider_eye": "蜘蛛眼",
  "item.minecraft.spider_spawn_egg": "蜘蛛生成蛋",
  "item.minecraft.spire_armor_trim_smithing_template": "鍛造模板",
  "item.minecraft.spire_armor_trim_smithing_template.new": "尖塔盔甲紋飾",
  "item.minecraft.splash_potion": "飛濺藥水",
  "item.minecraft.splash_potion.effect.awkward": "飛濺型粗製藥水",
  "item.minecraft.splash_potion.effect.empty": "飛濺型不可合成的藥水",
  "item.minecraft.splash_potion.effect.fire_resistance": "飛濺型抗火藥水",
  "item.minecraft.splash_potion.effect.harming": "飛濺型傷害藥水",
  "item.minecraft.splash_potion.effect.healing": "飛濺型治療藥水",
  "item.minecraft.splash_potion.effect.infested": "飛濺型蛀蝕藥水",
  "item.minecraft.splash_potion.effect.invisibility": "飛濺型隱形藥水",
  "item.minecraft.splash_potion.effect.leaping": "飛濺型跳躍藥水",
  "item.minecraft.splash_potion.effect.levitation": "飛濺型飄浮藥水",
  "item.minecraft.splash_potion.effect.luck": "飛濺型幸運藥水",
  "item.minecraft.splash_potion.effect.mundane": "飛濺型平凡藥水",
  "item.minecraft.splash_potion.effect.night_vision": "飛濺型夜視藥水",
  "item.minecraft.splash_potion.effect.oozing": "飛濺型滲漿藥水",
  "item.minecraft.splash_potion.effect.poison": "飛濺型劇毒藥水",
  "item.minecraft.splash_potion.effect.regeneration": "飛濺型回復藥水",
  "item.minecraft.splash_potion.effect.slow_falling": "飛濺型緩降藥水",
  "item.minecraft.splash_potion.effect.slowness": "飛濺型緩速藥水",
  "item.minecraft.splash_potion.effect.strength": "飛濺型力量藥水",
  "item.minecraft.splash_potion.effect.swiftness": "飛濺型迅捷藥水",
  "item.minecraft.splash_potion.effect.thick": "飛濺型黏稠藥水",
  "item.minecraft.splash_potion.effect.turtle_master": "飛濺型神龜藥水",
  "item.minecraft.splash_potion.effect.water": "飛濺型水樽",
  "item.minecraft.splash_potion.effect.water_breathing": "飛濺型水中呼吸藥水",
  "item.minecraft.splash_potion.effect.weakness": "飛濺型虛弱藥水",
  "item.minecraft.splash_potion.effect.weaving": "飛濺型織網藥水",
  "item.minecraft.splash_potion.effect.wind_charged": "飛濺型蓄風藥水",
  "item.minecraft.spruce_boat": "杉木船",
  "item.minecraft.spruce_chest_boat": "儲物箱杉木船",
  "item.minecraft.spyglass": "望遠鏡",
  "item.minecraft.squid_spawn_egg": "墨魚生成蛋",
  "item.minecraft.stick": "木棍",
  "item.minecraft.stone_axe": "石斧頭",
  "item.minecraft.stone_hoe": "石鋤頭",
  "item.minecraft.stone_pickaxe": "石鎬",
  "item.minecraft.stone_shovel": "石鏟",
  "item.minecraft.stone_spear": "石矛",
  "item.minecraft.stone_sword": "石劍",
  "item.minecraft.stray_spawn_egg": "流浪者生成蛋",
  "item.minecraft.strider_spawn_egg": "熾足獸生成蛋",
  "item.minecraft.string": "線",
  "item.minecraft.sugar": "糖",
  "item.minecraft.suspicious_stew": "可疑的燉湯",
  "item.minecraft.sweet_berries": "甜莓",
  "item.minecraft.tadpole_bucket": "蝌蚪桶",
  "item.minecraft.tadpole_spawn_egg": "蝌蚪生成蛋",
  "item.minecraft.tide_armor_trim_smithing_template": "鍛造模板",
  "item.minecraft.tide_armor_trim_smithing_template.new": "潮汐盔甲紋飾",
  "item.minecraft.tipped_arrow": "藥水箭",
  "item.minecraft.tipped_arrow.effect.awkward": "藥水箭",
  "item.minecraft.tipped_arrow.effect.empty": "不可合成的藥水箭",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "抗火之箭",
  "item.minecraft.tipped_arrow.effect.harming": "傷害之箭",
  "item.minecraft.tipped_arrow.effect.healing": "治療之箭",
  "item.minecraft.tipped_arrow.effect.infested": "蛀蝕之箭",
  "item.minecraft.tipped_arrow.effect.invisibility": "隱形之箭",
  "item.minecraft.tipped_arrow.effect.leaping": "跳躍之箭",
  "item.minecraft.tipped_arrow.effect.levitation": "飄浮之箭",
  "item.minecraft.tipped_arrow.effect.luck": "幸運之箭",
  "item.minecraft.tipped_arrow.effect.mundane": "藥水箭",
  "item.minecraft.tipped_arrow.effect.night_vision": "夜視之箭",
  "item.minecraft.tipped_arrow.effect.oozing": "滲漿之箭",
  "item.minecraft.tipped_arrow.effect.poison": "劇毒之箭",
  "item.minecraft.tipped_arrow.effect.regeneration": "回復之箭",
  "item.minecraft.tipped_arrow.effect.slow_falling": "緩降之箭",
  "item.minecraft.tipped_arrow.effect.slowness": "緩速之箭",
  "item.minecraft.tipped_arrow.effect.strength": "力量之箭",
  "item.minecraft.tipped_arrow.effect.swiftness": "迅捷之箭",
  "item.minecraft.tipped_arrow.effect.thick": "藥水箭",
  "item.minecraft.tipped_arrow.effect.turtle_master": "神龜之箭",
  "item.minecraft.tipped_arrow.effect.water": "飛濺之箭",
  "item.minecraft.tipped_arrow.effect.water_breathing": "水中呼吸之箭",
  "item.minecraft.tipped_arrow.effect.weakness": "虛弱之箭",
  "item.minecraft.tipped_arrow.effect.weaving": "織網之箭",
  "item.minecraft.tipped_arrow.effect.wind_charged": "蓄風之箭",
  "item.minecraft.tnt_minecart": "TNT 礦車",
  "item.minecraft.torchflower_seeds": "火炬花種子",
  "item.minecraft.totem_of_undying": "不死圖騰",
  "item.minecraft.trader_llama_spawn_egg": "商隊羊駝生成蛋",
  "item.minecraft.trial_key": "試煉鎖匙",
  "item.minecraft.trident": "三叉戟",
  "item.minecraft.tropical_fish": "熱帶魚",
  "item.minecraft.tropical_fish_bucket": "熱帶魚桶",
  "item.minecraft.tropical_fish_spawn_egg": "熱帶魚生成蛋",
  "item.minecraft.turtle_helmet": "海龜殼",
  "item.minecraft.turtle_scute": "海龜鱗甲",
  "item.minecraft.turtle_spawn_egg": "海龜生成蛋",
  "item.minecraft.vex_armor_trim_smithing_template": "鍛造模板",
  "item.minecraft.vex_armor_trim_smithing_template.new": "惱鬼盔甲紋飾",
  "item.minecraft.vex_spawn_egg": "惱鬼生成蛋",
  "item.minecraft.villager_spawn_egg": "村民生成蛋",
  "item.minecraft.vindicator_spawn_egg": "衞道士生成蛋",
  "item.minecraft.wandering_trader_spawn_egg": "流浪商人生成蛋",
  "item.minecraft.ward_armor_trim_smithing_template": "鍛造模板",
  "item.minecraft.ward_armor_trim_smithing_template.new": "守衞盔甲紋飾",
  "item.minecraft.warden_spawn_egg": "沉靈守衞生成蛋",
  "item.minecraft.warped_fungus_on_a_stick": "迷離菌菇魚竿",
  "item.minecraft.water_bucket": "水桶",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "鍛造模板",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "嚮導盔甲紋飾",
  "item.minecraft.wheat": "小麥",
  "item.minecraft.wheat_seeds": "小麥種子",
  "item.minecraft.white_bundle": "白色收納袋",
  "item.minecraft.white_dye": "白色染料",
  "item.minecraft.white_harness": "白色牽引器具",
  "item.minecraft.wild_armor_trim_smithing_template": "鍛造模板",
  "item.minecraft.wild_armor_trim_smithing_template.new": "荒野盔甲紋飾",
  "item.minecraft.wind_charge": "風彈",
  "item.minecraft.witch_spawn_egg": "女巫生成蛋",
  "item.minecraft.wither_skeleton_spawn_egg": "凋零骷髏骨生成蛋",
  "item.minecraft.wither_spawn_egg": "凋零怪生成蛋",
  "item.minecraft.wolf_armor": "狼甲",
  "item.minecraft.wolf_spawn_egg": "狼生成蛋",
  "item.minecraft.wooden_axe": "木斧頭",
  "item.minecraft.wooden_hoe": "木鋤頭",
  "item.minecraft.wooden_pickaxe": "木鎬",
  "item.minecraft.wooden_shovel": "木鏟",
  "item.minecraft.wooden_spear": "木矛",
  "item.minecraft.wooden_sword": "木劍",
  "item.minecraft.writable_book": "書與羽毛筆",
  "item.minecraft.written_book": "寫好的書",
  "item.minecraft.yellow_bundle": "黃色收納袋",
  "item.minecraft.yellow_dye": "黃色染料",
  "item.minecraft.yellow_harness": "黃色牽引器具",
  "item.minecraft.zoglin_spawn_egg": "豬屍獸生成蛋",
  "item.minecraft.zombie_horse_spawn_egg": "喪屍馬生成蛋",
  "item.minecraft.zombie_nautilus_spawn_egg": "喪屍鸚鵡螺生成蛋",
  "item.minecraft.zombie_spawn_egg": "喪屍生成蛋",
  "item.minecraft.zombie_villager_spawn_egg": "喪屍村民生成蛋",
  "item.minecraft.zombified_piglin_spawn_egg": "喪屍豬人生成蛋"
}
export const zh_hk = items; 
